
(function(){
  'use strict';

  var MM_SWATCH_ICON='data:image/png;base64,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';

  function ensureQuoteSimplifyStyles(){
    if(document.getElementById('mm-quote-simplify-styles'))return;
    var style=document.createElement('style');
    style.id='mm-quote-simplify-styles';
    style.textContent=
      '.mm-qty-button{touch-action:pan-y!important}'+
      '.mm-qty.is-entered>label{color:#000080!important;font-weight:800!important;text-shadow:none!important}'+
      '.mm-qty-control.is-entered{border-top:2px solid #fff!important;border-left:2px solid #fff!important;border-right:2px solid #404040!important;border-bottom:2px solid #404040!important;border-radius:0!important;background:#c0c0c0!important;box-shadow:1px 1px 0 #000!important}'+
      '.mm-qty-control.is-entered .mm-input,.mm-qty-control.is-entered .mm-input:focus{background:#000080!important;color:#fff!important;font-family:Tahoma,Verdana,Arial,sans-serif!important;font-weight:800!important;text-shadow:1px 1px 0 #000;box-shadow:inset 1px 1px 0 #000,inset -1px -1px 0 #fff!important}'+
      /* Navy-filled values already look selected; invert the field on focus so the actual text selection is unmistakable. */
      '[data-mm-quote] .mm-qty-control .mm-input:focus,[data-mm-quote] .mm-qty-control.is-entered .mm-input:focus{background:#ffffff!important;color:#000080!important;text-shadow:none!important;caret-color:#000080!important;outline:2px solid #000080!important;outline-offset:-2px}'+
      '[data-mm-quote] .mm-qty-control .mm-input::selection,[data-mm-quote] [data-role="qty-extra"]::selection,[data-mm-quote] [data-role="other-qty"]::selection,[data-mm-quote] [data-mm-estimate-edit-quantity]::selection{background:#000080!important;color:#ffffff!important;text-shadow:none!important}'+
      '.mm-qty-control.is-entered .mm-qty-button{background:#c0c0c0!important;color:#000!important;border-radius:0!important}'+
      '.mm-qty-control.is-entered .mm-qty-button:active{background:#d4d0c8!important}'+
      '[data-mm-quote] [data-role="quantity-title"]{display:flex!important;align-items:baseline;justify-content:space-between;gap:12px;width:100%;margin-bottom:18px!important}'+
      '[data-mm-quote] .mm-quantity-heading-total{margin-left:auto;color:#000000!important;font:inherit!important;font-weight:700!important;white-space:nowrap;text-shadow:none!important}'+
      '[data-mm-quote] [data-role="quantity-total"]{display:none!important}'+
      '[data-mm-quote] .mm-required{display:none!important}'+
      '[data-mm-quote] [data-mm-details-section] .mm-required{display:inline!important;color:#a00000!important}'+
      '[data-mm-quote] .mm-garment-status,[data-mm-quote] .mm-next-step,[data-mm-quote] [data-mm-review-garments]{display:none!important}'+
      '[data-mm-quote] .mm-garment-progress__meta{display:none!important}'+
      '[data-mm-quote] .mm-artwork-guidance>span{display:none!important}'+
      '[data-mm-quote] .mm-add-garment-wrap,[data-mm-quote] [data-mm-add-colour]{display:none!important}'+
      '[data-mm-quote] .mm-mobile-step-summary{cursor:pointer}'+
      '[data-mm-quote] .mm-mobile-step-summary button,[data-mm-quote] .mm-garment-compact__actions [data-mm-edit-garment]{display:none!important}'+
      '.mm-flow-hidden{display:none!important}'+
      '.mm-flow-primary,.mm-flow-secondary{appearance:none;width:100%;min-height:48px;padding:9px 14px;border-radius:0;font:700 1.18rem/1.2 Tahoma,Verdana,Arial,sans-serif;cursor:pointer}'+
      '.mm-flow-primary{border-top:2px solid #fff;border-left:2px solid #fff;border-right:2px solid #404040;border-bottom:2px solid #404040;background:#000080;color:#fff;text-shadow:1px 1px 0 #000;box-shadow:1px 1px 0 #000}'+
      '.mm-flow-primary:active{border-top-color:#404040;border-left-color:#404040;border-right-color:#fff;border-bottom-color:#fff;transform:translate(1px,1px);box-shadow:none}'+
      '.mm-flow-secondary{border-top:2px solid #fff;border-left:2px solid #fff;border-right:2px solid #404040;border-bottom:2px solid #404040;background:#c0c0c0;color:#000;box-shadow:1px 1px 0 #000}'+
      '.mm-flow-link{appearance:none;border:0;background:transparent;color:#000080;font:700 1.05rem/1.2 Tahoma,Verdana,Arial,sans-serif;text-decoration:underline;cursor:pointer;padding:4px 0}'+
      '.mm-flow-backbar{display:flex;justify-content:flex-start;padding:8px 12px;background:#c0c0c0}'+
      '.mm-flow-backbar.mm-hidden{display:none!important}'+
      '.mm-flow-back-button{appearance:none;min-width:88px;padding:6px 12px;border-top:2px solid #fff;border-left:2px solid #fff;border-right:2px solid #404040;border-bottom:2px solid #404040;border-radius:0;background:#c0c0c0;color:#000;font:700 1.05rem/1.1 Tahoma,Verdana,Arial,sans-serif;box-shadow:1px 1px 0 #000;cursor:pointer}'+
      '.mm-flow-back-button:active{border-top-color:#404040;border-left-color:#404040;border-right-color:#fff;border-bottom-color:#fff;transform:translate(1px,1px);box-shadow:none}'+
      '.mm-flow-actions{display:grid;gap:8px;margin:14px 0 4px}'+
      '.mm-flow-topbar{display:flex;align-items:center;justify-content:flex-start;margin:0 0 12px}'+
      '.mm-garment-finish{margin:16px 0 2px}'+
      '.mm-garment-done-actions{display:flex;gap:8px;flex-wrap:wrap;padding:10px 12px 12px;background:#d4d0c8}'+
      '.mm-garment-done-actions.mm-hidden{display:none!important}'+
      '.mm-garment-block.mm-garment-collapsed>.mm-garment-done-actions{display:flex!important}'+
      '.mm-garment-block.mm-garment-collapsed>.mm-garment-done-actions.mm-hidden{display:none!important}'+
      '.mm-garment-done-actions .mm-flow-secondary{width:auto;flex:1 1 220px;min-height:42px;font-size:1.05rem}'+
      '.mm-garment-compact{cursor:pointer}'+
      '.mm-garment-compact__copy{flex:1 1 auto}'+
      '.mm-garment-compact__type-icon{flex:0 0 auto;min-width:96px;height:54px;display:flex;align-items:center;justify-content:center;gap:8px;margin-left:auto;margin-right:8px;pointer-events:none}'+
      '.mm-garment-compact__type-icon img{display:block;max-width:48px;max-height:44px;width:auto;height:auto;object-fit:contain;filter:brightness(0)}'+
      '.mm-garment-compact__qty{display:block;color:#000080!important;font:700 1.6rem/1 Tahoma,Verdana,Arial,sans-serif!important;white-space:nowrap;text-shadow:none!important}'+
      '.mm-flow-add-more{display:flex;gap:8px;flex-wrap:wrap;margin:10px 0 16px}'+
      '.mm-flow-add-more.mm-hidden{display:none!important}'+
      '.mm-flow-add-more .mm-flow-secondary{width:auto;flex:1 1 260px;min-height:44px;font-size:1.05rem}'+
      '.mm-garment-block.mm-garment-collapsed.mm-garment-colour-editing>[data-role="details-section"]{display:block!important;padding:10px 12px 12px;background:#d4d0c8}'+
      '.mm-garment-block.mm-garment-colour-editing>[data-role="details-section"]>.mm-field,.mm-garment-block.mm-garment-colour-editing>[data-role="details-section"]>[data-mm-add-colour]{display:none!important}'+
      '.mm-garment-block.mm-garment-colour-editing .mm-extra-colours{display:block!important;margin:0}'+
      '.mm-garment-block.mm-garment-colour-editing [data-mm-extra-colour]{display:none!important}'+
      '.mm-garment-block.mm-garment-colour-editing [data-mm-extra-colour].mm-extra-colour--active{display:block!important;margin:0;padding:12px;border-top:2px solid #fff;border-left:2px solid #fff;border-right:2px solid #404040;border-bottom:2px solid #404040;border-radius:0;background:#d4d0c8;box-shadow:1px 1px 0 #000}'+
      '.mm-garment-block.mm-garment-colour-editing .mm-extra-colour__head{margin:0 0 12px;padding:0 0 8px;border-bottom:1px solid #808080}'+
      '.mm-garment-block.mm-garment-colour-editing .mm-extra-colour__head strong{color:#000080!important;text-shadow:none!important}'+
      '.mm-garment-block.mm-garment-colour-editing .mm-extra-colour__head button{color:#800000!important}'+
      '.mm-garment-block.mm-garment-colour-editing .mm-extra-colour--awaiting-colour [data-mm-extra-quantity-heading],.mm-garment-block.mm-garment-colour-editing .mm-extra-colour--awaiting-colour [data-mm-extra-quantity-grid],.mm-garment-block.mm-garment-colour-editing .mm-extra-colour--awaiting-colour [data-mm-extra-colour-done]{display:none!important}'+
      '.mm-garment-block.mm-garment-colour-editing [data-mm-extra-colour-grid] .mm-choice:has(input[value="Other"]) .mm-choice-image img{filter:brightness(0)!important}'+
      '.mm-garment-block.mm-garment-colour-editing [data-mm-extra-colour-done]{margin-top:12px}'+
      '.mm-optional-tag{margin-left:5px;color:#555;font-size:.82em;font-weight:400}'+
      '[data-mm-final-review-section] .mm-submit{background:#000080!important;color:#fff!important;text-shadow:1px 1px 0 #000!important}'+
      '@media(max-width:749px){.mm-garment-done-actions{display:grid!important;grid-template-columns:1fr}.mm-garment-done-actions.mm-hidden{display:none!important}.mm-garment-done-actions .mm-flow-secondary{width:100%}.mm-flow-add-more{display:grid;grid-template-columns:1fr}.mm-flow-add-more.mm-hidden{display:none!important}.mm-flow-add-more .mm-flow-secondary{width:100%}.mm-garment-compact__type-icon{min-width:78px;height:44px;margin-right:4px;gap:6px}.mm-garment-compact__type-icon img{max-width:38px;max-height:36px}.mm-garment-compact__qty{font-size:1.35rem!important}.mm-flow-primary,.mm-flow-secondary{font-size:1.14rem}}';
    document.head.appendChild(style);
  }

  function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function cdnThumb(url,width){
    if(!url)return '';
    if(/^data:/i.test(url))return url;
    if(!/cdn\.shopify\.com|\/cdn\/shop\/files\//i.test(url))return url;
    var join=url.indexOf('?')===-1?'?':'&';
    return url.replace(/([?&])width=\d+(&|$)/,'$1').replace(/[?&]$/,'')+join+'width='+width;
  }

  function choiceCard(opt,name,type,width,loading){
    var src=opt.image?cdnThumb(opt.image,width||320):'';
    var img=src?'<span class="mm-choice-image"><img src="'+esc(src)+'" alt="" loading="'+(loading||'lazy')+'" decoding="async"></span>':'';
    var info='';
    if(opt.description){
      info='<span class="mm-choice-info" role="button" tabindex="0" aria-label="About '+esc(opt.label)+'" onclick="event.preventDefault();event.stopPropagation();this.classList.toggle(\'is-open\')" onkeydown="if(event.key===\'Enter\'||event.key===\' \'){event.preventDefault();event.stopPropagation();this.classList.toggle(\'is-open\')}" onblur="this.classList.remove(\'is-open\')">i'+
        '<span class="mm-choice-tooltip">'+esc(opt.description)+'</span></span>';
    }
    return '<label class="mm-choice">'+info+img+'<input type="'+type+'" name="'+esc(name)+'" value="'+esc(opt.value)+'"><span class="mm-choice-label">'+esc(opt.label)+'</span></label>';
  }
  function normalGarmentName(v){
    return String(v||'')
      .replace(/\s*-\s*From\s*\$[\d.]+/ig,'')
      .replace(/^Budget Pick\s*-\s*/i,'')
      .replace(/^Our Pick\s*-\s*/i,'')
      .trim()
      .toLowerCase();
  }

  function garmentPricingUrl(data,type,garment){
    var target=normalGarmentName(garment && (garment.label||garment.value));
    var found=Object.entries(data.slugMap||{}).find(function(entry){
      var pair=entry[1]||[];
      return pair[0]===type && normalGarmentName(pair[1])===target;
    });
    return found ? '/pages/catalog?garment='+encodeURIComponent(found[0]) : '/pages/catalog';
  }

  function representativeGarment(data,type){
    var wanted={
      'T-Shirt':'Gildan 5000',
      'Hoodie':'ATCF2500',
      'Tank Top':'ATC1004',
      'Sweatshirt':'ATCF2400'
    }[type];
    if(!wanted)return null;
    return (data.garments[type]||[]).find(function(g){
      return String(g.label||'').toLowerCase().indexOf(wanted.toLowerCase())===0;
    })||null;
  }

  function combinedCategorySizes(data,type){
    var preferredOrder=['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL','8XL'];
    var seen={};
    (data.garments[type]||[]).forEach(function(garment){
      (garment.sizes||[]).forEach(function(size){seen[size]=true;});
    });
    var ordered=preferredOrder.filter(function(size){return seen[size];});
    Object.keys(seen).forEach(function(size){
      if(ordered.indexOf(size)===-1)ordered.push(size);
    });
    return ordered;
  }

  function quantityColumnCount(count){
    if(count>=7)return 4;
    if(count>=5)return 3;
    return Math.max(1,count);
  }

  function renderQuantities(block,sizes,note){
    var box=block.querySelector('[data-role="quantity-grid"]');
    var noteEl=block.querySelector('[data-role="size-note"]');
    var use=(sizes&&sizes.length?sizes:['S','M','L','XL','2XL','3XL']);
    block._mmSizes=use.slice();
    box.dataset.mmQtyCols=String(quantityColumnCount(use.length));
    box.innerHTML=use.map(function(size){
      return '<div class="mm-qty"><label>'+esc(size)+'</label>'+
        '<div class="mm-qty-control">'+
          '<button type="button" class="mm-qty-button" data-mm-qty-minus aria-label="Decrease '+esc(size)+' quantity">−</button>'+
          '<input class="mm-input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="off" value="" placeholder="0" data-role="qty" data-size="'+esc(size)+'" aria-label="'+esc(size)+' quantity">'+
          '<button type="button" class="mm-qty-button" data-mm-qty-plus aria-label="Increase '+esc(size)+' quantity">+</button>'+
        '</div></div>';
    }).join('');
    if(noteEl) noteEl.textContent='';
  }

  function primaryColourValue(block){
    var mode=block.dataset.mode||'';
    if(mode==='exact')return selectedValue(block.querySelector('[data-role="color-grid"]'));
    if(mode==='lowest'||mode==='recommend'){
      var value=selectedValue(block.querySelector('[data-role="preferred-grid"]'));
      if(value==='Other')return block.querySelector('[data-role="preferred-other-input"]').value.trim();
      return value;
    }
    return '';
  }

  function extraColourGroups(block){
    return Array.from(block.querySelectorAll('[data-mm-extra-colour]'));
  }

  function extraColourName(group){
    var select=group.querySelector('[data-mm-extra-colour-select]');
    var value=select?select.value:'';
    if(value==='Other'){
      var other=group.querySelector('[data-mm-extra-colour-other]');
      return other?other.value.trim():'';
    }
    return value;
  }

  function extraColourTotal(group){
    var total=0;
    group.querySelectorAll('[data-role="qty-extra"]').forEach(function(input){
      total+=(parseInt(input.value||'0',10)||0);
    });
    return total;
  }

  function extraColoursValid(block){
    return extraColourGroups(block).every(function(group){
      return !!extraColourName(group) && extraColourTotal(group)>0;
    });
  }

  function quantityParts(container,selector){
    var out=[];
    container.querySelectorAll(selector).forEach(function(input){
      var n=parseInt(input.value||'0',10)||0;
      if(n>0)out.push(input.dataset.size+' '+n);
    });
    return out;
  }

  function colourBreakdowns(block){
    var out=[];
    var byColour=new Map();

    function addColour(name,container,selector){
      var colour=String(name||'').trim();
      if(!colour)return;
      var key=colour.toLowerCase();
      var entry=byColour.get(key);
      if(!entry){
        entry={colour:colour,total:0,sizeMap:new Map()};
        byColour.set(key,entry);
        out.push(entry);
      }

      container.querySelectorAll(selector).forEach(function(input){
        var n=parseInt(input.value||'0',10)||0;
        if(n<=0)return;
        var size=input.dataset.size||'';
        entry.total+=n;
        entry.sizeMap.set(size,(entry.sizeMap.get(size)||0)+n);
      });
    }

    addColour(primaryColourValue(block),block,'[data-role="qty"]');
    extraColourGroups(block).forEach(function(group){
      addColour(extraColourName(group),group,'[data-role="qty-extra"]');
    });

    return out.map(function(entry){
      return {
        colour:entry.colour,
        total:entry.total,
        sizes:Array.from(entry.sizeMap.entries()).map(function(pair){return pair[0]+' '+pair[1];})
      };
    });
  }

  function colourImage(garment,colour){
    if(!garment||!Array.isArray(garment.colors))return '';
    var c=garment.colors.find(function(x){
      return String(x.label||x.value||'').trim().toLowerCase()===colour.toLowerCase();
    });
    return c&&c.image ? c.image : '';
  }

  function garmentPreviewOption(garment){
    var image=colourImage(garment,'Black') || (garment.colors&&garment.colors[0]&&garment.colors[0].image) || garment.image || '';
    return {
      label:garment.label,
      value:garment.value,
      description:garment.description,
      image:image
    };
  }

  function modeChoiceCard(opt,name,blackImage,whiteImage){
    var images='';
    if(blackImage||whiteImage){
      images='<span class="mm-choice-image mm-choice-pair">'+
        (blackImage?'<span><img src="'+esc(blackImage)+'" alt="" loading="lazy"></span>':'')+
        (whiteImage?'<span><img src="'+esc(whiteImage)+'" alt="" loading="lazy"></span>':'')+
      '</span>';
    }
    return '<label class="mm-choice mm-mode-choice">'+images+
      '<input type="radio" name="'+esc(name)+'" value="'+esc(opt.value)+'">'+
      '<span class="mm-choice-label">'+esc(opt.label)+'</span></label>';
  }
  function bindChoiceGrid(box,onChange){
    var reselectInput=null;
    var reselectWasChecked=false;
    var reselectStartX=0;
    var reselectStartY=0;
    var reselectMoved=false;

    box.addEventListener('pointerdown',function(e){
      if(e.target.closest('.mm-choice-info'))return;
      var card=e.target.closest('.mm-choice');
      var input=card&&card.querySelector('input[type="radio"]');
      reselectInput=input||null;
      reselectWasChecked=!!(input&&input.checked);
      reselectStartX=e.clientX;
      reselectStartY=e.clientY;
      reselectMoved=false;
    });

    box.addEventListener('pointermove',function(e){
      if(!reselectInput)return;
      if(Math.abs(e.clientX-reselectStartX)>9||Math.abs(e.clientY-reselectStartY)>9)reselectMoved=true;
    });

    box.addEventListener('pointerup',function(e){
      if(!reselectInput)return;
      var input=reselectInput;
      var wasChecked=reselectWasChecked;
      var moved=reselectMoved;
      reselectInput=null;
      reselectWasChecked=false;
      reselectMoved=false;
      if(!moved&&wasChecked&&input.checked&&onChange)onChange(input,e);
    });

    box.addEventListener('pointercancel',function(){
      reselectInput=null;
      reselectWasChecked=false;
      reselectMoved=false;
    });

    box.addEventListener('change',function(e){
      if(!e.target.matches('input')) return;
      if(e.target.type==='radio'){
        box.querySelectorAll('.mm-choice').forEach(function(x){x.classList.toggle('is-selected',!!x.querySelector('input:checked'));});
      }else{
        var p=e.target.closest('.mm-choice'); if(p) p.classList.toggle('is-selected',e.target.checked);
      }
      onChange && onChange(e.target,e);
    });
  }
  function selectedValue(box){var x=box.querySelector('input:checked');return x?x.value:'';}
  function selectedValues(box){return Array.from(box.querySelectorAll('input:checked')).map(function(x){return x.value;});}
  function show(el,yes){if(!el)return;el.classList.toggle('mm-hidden',!yes);}
  function errorAt(block,msg){
    var old=block.querySelector('.mm-field-error[data-mm-custom-error]'); if(old) old.remove();
    if(!msg)return;
    var p=document.createElement('p');p.className='mm-field-error';p.dataset.mmCustomError='1';p.textContent=msg;block.appendChild(p);
  }
  function slugChoice(data){
    var g=new URLSearchParams(location.search).get('garment');
    return g && data.slugMap ? data.slugMap[g] : null;
  }

  var MM_ESTIMATE_HANDOFF_KEY='mmEstimatorHandoffV1';
  var MM_ESTIMATE_ORIGINAL_KEY='mmEstimatorOriginalV1';

  function estimatorMoney(value){
    var n=Number(value);
    return Number.isFinite(n) ? '$'+n.toFixed(2) : '—';
  }

  function readEstimatorStorage(key){
    try{
      var snapshot=JSON.parse(sessionStorage.getItem(key)||'null');
      return snapshot&&snapshot.version===1 ? snapshot : null;
    }catch(error){
      return null;
    }
  }

  function readEstimatorHandoff(){
    var params=new URLSearchParams(location.search);
    if(params.get('from')!=='estimator')return null;
    return readEstimatorStorage(MM_ESTIMATE_HANDOFF_KEY);
  }

  function estimateLocationLabel(value){
    return {
      'right-chest':'Right Chest',
      'left-chest':'Left Chest',
      'full-front':'Full Front',
      'full-back':'Back',
      'right-chest-back':'Right Chest + Back',
      'left-chest-back':'Left Chest + Back',
      'front-back':'Full Front + Back'
    }[value]||value||'';
  }

  function estimateLocationSelections(value){
    var names={
      'right-chest':['Right Chest'],
      'left-chest':['Left Chest'],
      'full-front':['Full Front'],
      'full-back':['Back'],
      'right-chest-back':['Right Chest','Back'],
      'left-chest-back':['Left Chest','Back'],
      'front-back':['Full Front','Back']
    };
    return names[value]||[];
  }

  function estimateColoursLabel(value){
    return {
      '1':'1 Colour',
      '2':'2 Colours',
      '3':'3 Colours',
      '4':'4 Colours',
      '5':'5 Colours',
      '6':'6 Colours',
      'full':'Full Colour / Photo',
      'unsure':'Not Sure'
    }[String(value)]||value||'';
  }

  function estimatorMethodText(snapshot){
    var method=snapshot.printMethod||'';
    if(snapshot.methodSelection==='Customer override'){
      method += ' — Override';
      if(snapshot.recommendedMethod && snapshot.recommendedMethod!==snapshot.printMethod){
        method += ' (recommended: '+snapshot.recommendedMethod+')';
      }
    }else if(method){
      method += ' — Recommended';
    }
    return method;
  }

  function estimatorDetailsText(snapshot){
    if(!snapshot)return '';
    return [
      'Source: '+(snapshot.source||'Homepage Price Estimator'),
      'Quantity: '+(snapshot.quantity||''),
      'Garment type: '+(snapshot.garmentType||''),
      'Selected garment: '+(snapshot.selectedGarmentLabel||snapshot.selectedGarment||''),
      'Print location: '+(snapshot.printLocationLabel||snapshot.printLocation||''),
      'Print colours: '+(snapshot.coloursLabel||snapshot.colours||''),
      'Print method: '+(snapshot.printMethod||''),
      'Method selection: '+(snapshot.methodSelection||''),
      'Recommended method: '+(snapshot.recommendedMethod||''),
      'Estimated total: '+estimatorMoney(snapshot.estimatedTotal),
      'Estimated each: '+estimatorMoney(snapshot.estimatedEach),
      'Saved at: '+(snapshot.savedAt||''),
      snapshot.updatedAt ? 'Updated at: '+snapshot.updatedAt : ''
    ].filter(Boolean).join('\n');
  }

  function hydrateEstimatorHandoff(root,form){
    var current=readEstimatorHandoff();
    if(!current)return;

    var original=readEstimatorStorage(MM_ESTIMATE_ORIGINAL_KEY)||current;
    var summary=root.querySelector('[data-mm-estimator-summary]');
    var summaryView=root.querySelector('[data-mm-estimator-summary-view]');
    var editor=root.querySelector('[data-mm-estimator-editor]');
    var originalInput=form.querySelector('[data-mm-estimator-original]');
    var updatedInput=form.querySelector('[data-mm-estimator-updated]');
    if(!summary||!summaryView||!editor||!originalInput||!updatedInput)return;

    var editBtn=root.querySelector('[data-mm-edit-estimate]');
    var updateBtn=root.querySelector('[data-mm-update-estimate]');
    var cancelBtn=root.querySelector('[data-mm-cancel-estimate]');
    var errorEl=root.querySelector('[data-mm-estimate-edit-error]');
    var qtyInput=root.querySelector('[data-mm-estimate-edit-quantity]');
    var typeSelect=root.querySelector('[data-mm-estimate-edit-type]');
    var garmentSelect=root.querySelector('[data-mm-estimate-edit-garment]');
    var locationSelect=root.querySelector('[data-mm-estimate-edit-location]');
    var coloursSelect=root.querySelector('[data-mm-estimate-edit-colours]');
    var methodSelect=root.querySelector('[data-mm-estimate-edit-method]');
    var engine=window.MM_ESTIMATOR_ENGINE;

    function put(selector,value){
      var el=summary.querySelector(selector);
      if(el)el.textContent=value||'—';
    }

    function hasUpdate(snapshot){
      return !!(snapshot&&snapshot.updatedAt);
    }

    function renderSummary(snapshot){
      put('[data-mm-estimator-quantity]',String(snapshot.quantity||''));
      put('[data-mm-estimator-type]',snapshot.garmentType);
      put('[data-mm-estimator-garment]',snapshot.selectedGarmentLabel||snapshot.selectedGarment);
      put('[data-mm-estimator-location]',snapshot.printLocationLabel||snapshot.printLocation);
      put('[data-mm-estimator-colours]',snapshot.coloursLabel||snapshot.colours);
      put('[data-mm-estimator-method]',estimatorMethodText(snapshot));
      put('[data-mm-estimator-total]',estimatorMoney(snapshot.estimatedTotal));
      put('[data-mm-estimator-each]',estimatorMoney(snapshot.estimatedEach));

      var heading=summary.querySelector('[data-mm-estimator-heading]');
      var eyebrow=summary.querySelector('[data-mm-estimator-eyebrow]');
      if(heading)heading.textContent=hasUpdate(snapshot)?'Your Updated Estimate':'Your Estimate';
      if(eyebrow)eyebrow.textContent=hasUpdate(snapshot)?'UPDATED ON THE QUOTE PAGE':'FROM THE PRICE ESTIMATOR';

      originalInput.value=estimatorDetailsText(original);
      updatedInput.value=hasUpdate(snapshot)?estimatorDetailsText(snapshot):'';
    }

    function fillGarments(type,selected){
      var names=engine&&engine.garmentNames&&engine.garmentNames[type] ? engine.garmentNames[type] : [];
      garmentSelect.innerHTML=names.map(function(name){
        var label=(engine.garmentDisplayNames&&engine.garmentDisplayNames[name])||name;
        return '<option value="'+esc(name)+'">'+esc(label)+'</option>';
      }).join('');
      if(selected && names.indexOf(selected)!==-1)garmentSelect.value=selected;
      else if(names.length)garmentSelect.value=names[0];
    }

    function fillEditor(snapshot){
      qtyInput.value=snapshot.quantity||1;
      typeSelect.value=snapshot.garmentType||'T-Shirt';
      fillGarments(typeSelect.value,snapshot.selectedGarment);
      locationSelect.value=snapshot.printLocation||'left-chest';
      coloursSelect.value=String(snapshot.colours||'1');
      methodSelect.value=(snapshot.printMode==='screen'||snapshot.printMode==='dtf')?snapshot.printMode:'auto';
      show(errorEl,false);
      errorEl.textContent='';
    }

    function showEditor(){
      fillEditor(current);
      show(summaryView,false);
      show(editor,true);
    }

    function closeEditor(){
      show(editor,false);
      show(summaryView,true);
      show(errorEl,false);
      errorEl.textContent='';
    }

    typeSelect.addEventListener('change',function(){
      fillGarments(typeSelect.value,'');
    });

    editBtn.addEventListener('click',showEditor);
    cancelBtn.addEventListener('click',closeEditor);

    updateBtn.addEventListener('click',function(){
      var qty=Math.round(Number(qtyInput.value));
      if(!Number.isFinite(qty)||qty<1){
        errorEl.textContent='Enter a quantity of at least 1.';
        show(errorEl,true);
        return;
      }
      if(!engine||typeof engine.calculate!=='function'){
        errorEl.textContent='The estimator could not be loaded. Please refresh and try again.';
        show(errorEl,true);
        return;
      }

      var result=engine.calculate({
        quantity:qty,
        garmentType:typeSelect.value,
        selectedGarment:garmentSelect.value,
        printLocation:locationSelect.value,
        colours:coloursSelect.value,
        printMode:methodSelect.value
      });

      if(!result||!result.ok){
        errorEl.textContent=(result&&result.reason)||'That combination needs a custom quote.';
        show(errorEl,true);
        return;
      }

      current={
        version:1,
        source:original.source||'Homepage Price Estimator',
        savedAt:original.savedAt||new Date().toISOString(),
        updatedAt:new Date().toISOString(),
        quantity:result.quantity,
        garmentType:result.garmentType,
        selectedGarment:result.selectedGarment,
        selectedGarmentLabel:result.selectedGarmentLabel,
        printLocation:result.printLocation,
        printLocationLabel:estimateLocationLabel(result.printLocation),
        printLocations:estimateLocationSelections(result.printLocation),
        colours:result.colours,
        coloursLabel:estimateColoursLabel(result.colours),
        printMode:result.printMode,
        printMethod:result.printMethod,
        recommendedMethod:result.recommendedMethod,
        methodSelection:result.methodSelection,
        estimatedTotal:result.estimatedTotal,
        estimatedEach:result.estimatedEach
      };

      try{
        sessionStorage.setItem(MM_ESTIMATE_HANDOFF_KEY,JSON.stringify(current));
      }catch(error){}

      renderSummary(current);
      closeEditor();
    });

    renderSummary(current);
    show(summary,true);
  }

  var mmImagePromises=new Map();

  function warmImage(url,width){
    if(!url)return Promise.resolve();
    var src=cdnThumb(url,width);
    if(/^data:/i.test(src))return Promise.resolve();
    if(mmImagePromises.has(src))return mmImagePromises.get(src);

    var promise=new Promise(function(resolve){
      var img=new Image();
      img.decoding='async';
      img.onload=function(){resolve();};
      img.onerror=function(){resolve();};
      img.src=src;
      if(img.complete)resolve();
    });

    mmImagePromises.set(src,promise);
    return promise;
  }

  function warmOptions(options,width){
    return Promise.all((options||[]).map(function(o){
      return o&&o.image ? warmImage(o.image,width) : Promise.resolve();
    }));
  }

  function preloadGarmentChoices(data,type){
    (data.garments[type]||[]).forEach(function(g){
      if(g.image) warmImage(g.image,480);
    });

    var representative=representativeGarment(data,type);
    ['Black','White'].forEach(function(colour){
      var url=colourImage(representative,colour);
      if(url) warmImage(url,300);
    });
  }

  function preloadAllQuoteImages(data){
    // Keep initial quote load small, particularly in mobile Safari. The form
    // only displays garment types at first; hidden garment colours alone can
    // contain hundreds of image options. Those images load normally when the
    // relevant step becomes visible via revealGridWhenReady().
    (data.typeOptions||[]).forEach(function(o){
      if(o.image) warmImage(o.image,240);
    });
  }

  function revealGridWhenReady(section,box,options,width,html,shouldShow){
    var token=String(Date.now())+Math.random();
    box.dataset.mmRenderToken=token;
    box.innerHTML=html;
    box.style.visibility='';
    show(section,shouldShow!==false);

    // Never hide the next step while artwork thumbnails preload.
    // The controls must remain usable immediately; images can warm in the background.
    warmOptions(options,width).then(function(){
      if(box.dataset.mmRenderToken!==token)return;
      box.style.visibility='';
    });
  }

  function initQuote(root){
    // Quote-form quantities: select the complete value on focus, click or tap,
    // including dynamically added size/colour quantities and Edit Estimate.
    var quantityFields='[data-role="qty"],[data-role="qty-extra"],[data-role="other-qty"],[data-mm-estimate-edit-quantity]';
    function selectQuantityValue(field){
      // Select the whole existing quantity, rather than placing a caret inside it.
      window.requestAnimationFrame(function(){
        if(document.activeElement!==field)return;
        try{
          field.select();
          if(field.type==='text'&&field.value)field.setSelectionRange(0,field.value.length);
        }catch(error){}
      });
    }
    // Text inputs support a visibly highlighted value; number inputs do not.
    // Sanitize before the per-field quantity listeners calculate totals.
    root.addEventListener('input',function(event){
      if(!event.target.matches(quantityFields))return;
      if(event.target.type==='number')return;
      var clean=event.target.value.replace(/[^0-9]/g,'').slice(0,5);
      if(event.target.value!==clean)event.target.value=clean;
    },true);
    root.addEventListener('focusin',function(event){
      if(event.target.matches(quantityFields))selectQuantityValue(event.target);
    });
    root.addEventListener('click',function(event){
      if(event.target.matches(quantityFields))selectQuantityValue(event.target);
    });
    root.addEventListener('pointerup',function(event){
      if(!event.target.matches(quantityFields)||document.activeElement!==event.target)return;
      event.preventDefault();
      selectQuantityValue(event.target);
    });
    if(root.dataset.mmQuoteInitialized==='1')return true;
    var data=window.MM_QUOTE_DATA;
    if(!data)return false;

    var form=root.querySelector('form');
    var list=root.querySelector('[data-mm-garments]');
    var template=root.querySelector('template[data-mm-garment-template]');
    var addBtn=root.querySelector('[data-mm-add-garment]');

    if(!form||!list||!template||!template.content||!template.content.firstElementChild||!addBtn)return false;
    ensureQuoteSimplifyStyles();
    var addGarmentWrap=root.querySelector('[data-mm-add-garment-wrap]');
    var estimatorSummary=root.querySelector('[data-mm-estimator-summary]');
    var garmentsSection=root.querySelector('[data-mm-garments-section]');
    var artworkSection=root.querySelector('[data-mm-artwork-section]');
    var detailsSection=root.querySelector('[data-mm-details-section]');
    var notesSection=root.querySelector('[data-mm-notes-section]');
    var finalReviewSection=root.querySelector('[data-mm-final-review-section]');
    var finalReview=root.querySelector('[data-mm-final-review]');
    var summaryInput=form.querySelector('[data-mm-garment-summary]');
    var sourceInput=form.querySelector('[data-mm-source]');
    if(sourceInput) sourceInput.value=location.href;
    hydrateEstimatorHandoff(root,form);
    preloadAllQuoteImages(data);
    var seq=0;
    var activeBlock=null;
    var garmentStatus=root.querySelector('[data-mm-garment-status]');
    var garmentStatusText=root.querySelector('[data-mm-garment-status-text]');
    var garmentStatusFill=root.querySelector('[data-mm-garment-status-fill]');
    var nextStepGuide=root.querySelector('[data-mm-next-step]');
    var nextStepButton=root.querySelector('[data-mm-next-step-button]');
    var nextStepText=root.querySelector('[data-mm-next-step-text]');
    var artworkInput=form.querySelector('[data-mm-files]');
    var submitButton=form.querySelector('[data-mm-submit-quote]');
    var nextTarget=null;
    var nextTargetAcknowledged=false;
    var reviewBtn=root.querySelector('[data-mm-review-garments]');
    var review=root.querySelector('[data-mm-garment-review]');
    var reviewList=root.querySelector('[data-mm-garment-review-list]');
    var previousBodyOverflow='';
    var quoteStage='build';
    var flowContinueWrap=null;
    var flowContinueButton=null;
    var flowAddMoreWrap=null;
    var flowAddColourButton=null;
    var flowAddGarmentButton=null;
    var flowActionBlock=null;
    var flowDetailsActions=null;
    var flowReviewButton=null;
    var flowBackBar=null;
    var flowBackButton=null;
    var flowBackToBuild=null;
    var flowBackToDetails=null;

    function isMobileQuote(){
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function syncGarmentStatusTop(){
      if(!garmentStatus)return;
      if(isMobileQuote()){
        garmentStatus.style.removeProperty('top');
        return;
      }
      var header=document.querySelector('.section-header') || document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
      var headerHeight=header ? Math.ceil(header.getBoundingClientRect().height) : 74;
      garmentStatus.style.top=(headerHeight+10)+'px';
    }

    syncGarmentStatusTop();
    window.addEventListener('resize',syncGarmentStatusTop);
    window.addEventListener('load',syncGarmentStatusTop);
    var statusHeader=document.querySelector('.section-header') || document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if(statusHeader && window.ResizeObserver){
      var statusHeaderObserver=new ResizeObserver(syncGarmentStatusTop);
      statusHeaderObserver.observe(statusHeader);
    }

    function appendOptional(label){
      if(!label||label.querySelector('.mm-optional-tag'))return;
      var tag=document.createElement('span');
      tag.className='mm-optional-tag';
      tag.textContent='optional';
      label.appendChild(tag);
    }

    function prepareQuoteCopy(){
      var content=template.content;
      var typeLegend=content.querySelector('[data-mm-step-section="type"] .mm-legend');
      var modeLegend=content.querySelector('[data-mm-step-section="mode"] .mm-legend');
      var garmentLegend=content.querySelector('[data-mm-step-section="garment"] .mm-legend');
      var preferredLegend=content.querySelector('[data-mm-step-section="preferred"] .mm-legend');
      var locationsLegend=content.querySelector('[data-role="locations-section"] .mm-legend');
      if(typeLegend)typeLegend.textContent='Garment Type';
      if(modeLegend)modeLegend.textContent='Choose Garment';
      if(garmentLegend)garmentLegend.textContent='Garment';
      if(preferredLegend)preferredLegend.textContent='Colour';
      if(locationsLegend)locationsLegend.textContent='Print Locations';

      var company=form.querySelector('label[for^="MMQuoteCompany-"]');
      var address1=form.querySelector('label[for^="MMQuoteAddress1-"]');
      var address2=form.querySelector('label[for^="MMQuoteAddress2-"]');
      var province=form.querySelector('label[for^="MMQuoteProvince-"]');
      var postal=form.querySelector('label[for^="MMQuotePostal-"]');
      if(company){company.textContent='Company';appendOptional(company);}
      if(address1)address1.innerHTML='Address <span class="mm-required">*</span>';
      if(address2){address2.textContent='Apt / Unit / Suite';appendOptional(address2);}
      if(province)province.innerHTML='Province <span class="mm-required">*</span>';
      if(postal)postal.innerHTML='Postal Code <span class="mm-required">*</span>';

      if(notesSection){
        var notesTitle=notesSection.querySelector('.mm-form-section-title');
        if(notesTitle)notesTitle.textContent='Anything Else We Should Know?';
        var notesBox=notesSection.querySelector('textarea');
        if(notesBox)notesBox.placeholder='Optional';
      }
      if(finalReviewSection){
        var reviewTitle=finalReviewSection.querySelector('.mm-form-section-title');
        if(reviewTitle)reviewTitle.textContent='Review';
      }
    }

    function makeFlowButton(textValue,className,attr){
      var button=document.createElement('button');
      button.type='button';
      button.className=className;
      button.textContent=textValue;
      if(attr)button.setAttribute(attr,'');
      return button;
    }

    function ensureFlowControls(){
      if(!flowBackBar){
        var header=root.querySelector('.mm-form-header');
        flowBackBar=document.createElement('div');
        flowBackBar.className='mm-flow-backbar mm-hidden';
        flowBackButton=makeFlowButton('← Back','mm-flow-back-button','data-mm-flow-back');
        flowBackBar.appendChild(flowBackButton);
        if(header)header.insertAdjacentElement('afterend',flowBackBar);
        else form.insertBefore(flowBackBar,form.firstChild);

        flowBackButton.addEventListener('click',function(){
          if(quoteStage==='review')setQuoteStage('details',true);
          else if(quoteStage==='details')setQuoteStage('build',true);
        });
      }

      if(!flowAddMoreWrap && list){
        flowAddMoreWrap=document.createElement('div');
        flowAddMoreWrap.className='mm-flow-add-more mm-hidden';
        flowAddColourButton=makeFlowButton('Same garment, new colour','mm-flow-secondary','data-mm-flow-add-colour');
        flowAddGarmentButton=makeFlowButton('Different garment','mm-flow-secondary','data-mm-flow-add-garment');
        flowAddMoreWrap.appendChild(flowAddColourButton);
        flowAddMoreWrap.appendChild(flowAddGarmentButton);
        list.insertAdjacentElement('afterend',flowAddMoreWrap);

        flowAddColourButton.addEventListener('click',function(){
          var block=flowActionBlock;
          if(!block||!list.contains(block))return;
          activeBlock=block;

          var group=addExtraColour(block);
          if(!group)return;

          block.classList.add('mm-garment-colour-editing');
          group.classList.add('mm-extra-colour--active','mm-extra-colour--awaiting-colour');

          var title=group.querySelector('[data-mm-extra-title]');
          if(title)title.textContent='New Colour';

          var done=makeFlowButton('✓ Done With This Colour','mm-flow-primary mm-hidden','data-mm-extra-colour-done');
          group.appendChild(done);

          var colourSummary=group.querySelector('[data-mm-extra-colour-summary]');

          function syncMiniColourFlow(){
            var colourName=extraColourName(group);
            var hasColour=!!colourName;
            var hasQuantity=extraColourTotal(group)>0;
            var editingChoice=group.classList.contains('mm-extra-colour--editing-choice');

            group.classList.toggle('mm-extra-colour--awaiting-colour',!hasColour);
            group.classList.toggle('mm-extra-colour--colour-picked',hasColour&&!editingChoice);

            if(colourSummary){
              colourSummary.textContent=hasColour?'✓ '+colourName:'';
              colourSummary.classList.toggle('mm-hidden',!hasColour||editingChoice);
            }
            var headingColour=group.querySelector('[data-mm-extra-heading-colour]');
            var headingTotal=group.querySelector('[data-mm-extra-heading-total]');
            if(headingColour)headingColour.textContent=colourName||'';
            if(headingTotal)headingTotal.textContent='Total: '+String(extraColourTotal(group));

            done.classList.toggle('mm-hidden',!(hasColour&&hasQuantity&&!editingChoice));
            updateNextStepGuide();
          }

          if(colourSummary){
            colourSummary.addEventListener('click',function(){
              group.classList.add('mm-extra-colour--editing-choice');
              group.classList.remove('mm-extra-colour--colour-picked');
              colourSummary.classList.add('mm-hidden');
              done.classList.add('mm-hidden');
              setTimeout(function(){
                var grid=group.querySelector('[data-mm-extra-colour-grid]');
                if(grid)mmFocusAndScroll(grid);
              },20);
            });
          }

          group._mmSyncMiniColourFlow=syncMiniColourFlow;
          syncMiniColourFlow();
          refreshFlowState();

          done.addEventListener('click',function(){
            if(!extraColourName(group)||extraColourTotal(group)<=0)return;
            group.classList.remove('mm-extra-colour--active','mm-extra-colour--awaiting-colour');
            block.classList.remove('mm-garment-colour-editing');
            refreshExtraColourNumbers(block);
            collapseGarmentBlock(block);
            updateGlobalProgress();
            setTimeout(function(){
              if(flowAddMoreWrap&&!flowAddMoreWrap.classList.contains('mm-hidden')){
                flowAddMoreWrap.scrollIntoView({behavior:'smooth',block:'center'});
              }
            },40);
          });

          var select=group.querySelector('[data-mm-extra-colour-select]');
          setTimeout(function(){mmFocusAndScroll(select||group);},40);
        });

        flowAddGarmentButton.addEventListener('click',function(){
          addBtn.click();
        });
      }

      if(!flowContinueWrap && artworkSection){
        flowContinueWrap=document.createElement('div');
        flowContinueWrap.className='mm-flow-actions mm-hidden';
        flowContinueButton=makeFlowButton('Continue →','mm-flow-primary','data-mm-flow-continue');
        flowContinueWrap.appendChild(flowContinueButton);
        artworkSection.insertAdjacentElement('afterend',flowContinueWrap);
        flowContinueButton.addEventListener('click',function(){
          refreshFlowState();
          if(flowContinueWrap.classList.contains('mm-hidden'))return;
          setQuoteStage('details',true);
        });
      }

      if(!flowDetailsActions && notesSection){
        flowDetailsActions=document.createElement('div');
        flowDetailsActions.className='mm-flow-actions';
        flowReviewButton=makeFlowButton('Review Quote →','mm-flow-primary','data-mm-flow-review');
        flowDetailsActions.appendChild(flowReviewButton);
        notesSection.insertAdjacentElement('afterend',flowDetailsActions);
        flowReviewButton.addEventListener('click',function(){
          var invalid=mmValidateRequiredFields(form).filter(function(field){
            return detailsSection && detailsSection.contains(field);
          });
          if(invalid.length){
            mmFocusAndScroll(invalid[0]);
            updateNextStepGuide();
            return;
          }
          setQuoteStage('review',true);
        });
      }

    }

    function quoteSafeTop(mobile){
      var bottom=0;
      document.querySelectorAll('sticky-header,.section-header,.header-wrapper,header').forEach(function(el){
        var style=window.getComputedStyle(el);
        if(style.display==='none'||style.visibility==='hidden')return;
        var rect=el.getBoundingClientRect();
        if(rect.height<=0||rect.bottom<=0||rect.top>180)return;
        // Ignore very large wrappers; we only want the visible navigation edge.
        if(rect.height>180)return;
        bottom=Math.max(bottom,rect.bottom);
      });
      if(bottom<=0)bottom=mobile?75:72;
      return Math.min(170,Math.max(0,bottom))+(mobile?10:14);
    }

    function frameQuoteStage(stage,delay){
      setTimeout(function(){
        var mobile=isMobileQuote();
        var view=(window.visualViewport&&window.visualViewport.height)||window.innerHeight;
        var safeTop=quoteSafeTop(mobile);
        var safeBottom=view-(mobile?18:28);
        var available=safeBottom-safeTop;
        if(available<180)return;
        if(!root||!root.isConnected)return;

        // Stage changes should show the quote window from its own title bar.
        // Compact stages (Artwork and Review) can then appear as complete windows;
        // taller Details simply continues below the fold without losing its top.
        var rect=root.getBoundingClientRect();
        var stageGap=mobile?6:12;
        var desired=rect.top-(safeTop+stageGap);

        if(stage==='details'&&flowDetailsActions&&!flowDetailsActions.classList.contains('mm-flow-hidden')){
          var actionsRect=flowDetailsActions.getBoundingClientRect();
          var bottomGap=mobile?32:44;
          // Details is only slightly taller than the usable viewport on desktop.
          // Keep its top mostly framed, but nudge down just enough that Review Quote
          // has visible breathing room beneath it instead of sitting on the edge.
          var actionsBottomAfter=actionsRect.bottom-desired;
          var maxBottom=safeBottom-bottomGap;
          if(actionsBottomAfter>maxBottom)desired+=actionsBottomAfter-maxBottom;
        }

        if(Math.abs(desired)>8){
          window.scrollBy({
            top:desired,
            behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'
          });
        }
      },typeof delay==='number'?delay:45);
    }

    function setQuoteStage(stage,shouldScroll){
      quoteStage=stage;
      var build=stage==='build';
      var details=stage==='details';
      var reviewStage=stage==='review';

      if(flowBackBar)flowBackBar.classList.toggle('mm-hidden',build);
      if(estimatorSummary)estimatorSummary.classList.toggle('mm-flow-hidden',!build);
      if(garmentsSection)garmentsSection.classList.toggle('mm-flow-hidden',!build);
      if(flowAddMoreWrap)flowAddMoreWrap.classList.toggle('mm-flow-hidden',!build);
      if(artworkSection)artworkSection.classList.toggle('mm-flow-hidden',!build);
      if(flowContinueWrap)flowContinueWrap.classList.toggle('mm-flow-hidden',!build);
      if(detailsSection)detailsSection.classList.toggle('mm-flow-hidden',!details);
      if(notesSection)notesSection.classList.toggle('mm-flow-hidden',!details);
      if(flowDetailsActions)flowDetailsActions.classList.toggle('mm-flow-hidden',!details);
      if(finalReviewSection)finalReviewSection.classList.toggle('mm-flow-hidden',!reviewStage);

      refreshFlowState();
      renderFinalReview();
      updateNextStepGuide();

      if(shouldScroll)frameQuoteStage(stage,45);
    }

    function refreshFlowState(){
      var blocks=Array.from(list.children);
      var allLocked=blocks.length>0 && blocks.every(function(block){
        return progressState(block).complete &&
          block.classList.contains('mm-garment-collapsed') &&
          !block.classList.contains('mm-garment-colour-editing');
      });
      var files=Array.isArray(form._mmSelectedFiles)?form._mmSelectedFiles:[];
      var last=blocks[blocks.length-1]||null;
      var actionBlock=(activeBlock&&blocks.indexOf(activeBlock)!==-1&&activeBlock.classList.contains('mm-garment-collapsed'))?activeBlock:last;

      flowActionBlock=allLocked?actionBlock:null;

      if(flowAddMoreWrap){
        var showAddMore=quoteStage==='build'&&allLocked&&!!flowActionBlock;
        flowAddMoreWrap.classList.toggle('mm-hidden',!showAddMore);
        if(flowAddColourButton){
          var canAddColour=!!(flowActionBlock&&flowActionBlock.dataset.type&&flowActionBlock.dataset.type!=='Other'&&extraColourGroups(flowActionBlock).length<3);
          var typeLabel=flowActionBlock ? ({'T-Shirt':'shirt','Hoodie':'hoodie','Tank Top':'tank top','Sweatshirt':'sweatshirt'}[flowActionBlock.dataset.type]||'garment') : 'garment';
          flowAddColourButton.textContent='Same '+typeLabel+', new colour';
          flowAddColourButton.classList.toggle('mm-hidden',!canAddColour);
        }
      }

      if(quoteStage==='build'){
        if(artworkSection)artworkSection.classList.toggle('mm-flow-hidden',!allLocked);
        if(flowContinueWrap){
          var ready=allLocked&&files.length>0;
          flowContinueWrap.classList.toggle('mm-hidden',!ready);
          flowContinueWrap.classList.toggle('mm-flow-hidden',false);
        }
      }
    }

    function installGarmentFlow(block){
      var finish=makeFlowButton('✓ Done With This Garment','mm-flow-primary mm-garment-finish mm-hidden','data-mm-finish-garment');
      block.appendChild(finish);

      var compact=block.querySelector('[data-role="garment-compact"]');
      var locationContinue=block.querySelector('[data-mm-location-continue]');
      var locationContinueWrap=block.querySelector('[data-mm-location-continue-wrap]');

      if(locationContinue){
        locationContinue.addEventListener('click',function(event){
          var selected=selectedValues(block.querySelector('[data-role="locations-grid"]'));
          if(!selected.length)return;
          block.dataset.mmLocationsConfirmed='1';
          if(locationContinueWrap)show(locationContinueWrap,false);
          var details=block.querySelector('[data-role="details-section"]');
          show(details,true);
          updateProgress(block);
          gentleAdvance(details,event);
        });
      }

      finish.addEventListener('click',function(){
        if(!validateBlock(block))return;
        activeBlock=block;
        if(collapseGarmentBlock(block)){
          updateGlobalProgress();
          setTimeout(function(){
            if(artworkSection&&!artworkSection.classList.contains('mm-flow-hidden')){
              // Once garment choices are complete, show the whole compact build
              // stage from the Get a Quote title bar instead of centring Add More.
              frameQuoteStage('build',0);
            }else if(flowAddMoreWrap&&!flowAddMoreWrap.classList.contains('mm-hidden')){
              frameQuoteTarget(flowAddMoreWrap,0);
            }
          },40);
        }
      });

      if(compact){
        compact.setAttribute('role','button');
        compact.setAttribute('tabindex','0');
        compact.setAttribute('aria-label','Edit this garment');
        compact.addEventListener('click',function(event){
          if(event.target.closest('button'))return;
          setQuoteStage('build',false);
          expandGarmentBlock(block,true);
        });
        compact.addEventListener('keydown',function(event){
          if(event.key!=='Enter'&&event.key!==' ')return;
          event.preventDefault();
          setQuoteStage('build',false);
          expandGarmentBlock(block,true);
        });
      }

      block.querySelectorAll('[data-mm-step-summary]').forEach(function(summary){
        summary.setAttribute('role','button');
        summary.setAttribute('tabindex','0');
        summary.addEventListener('click',function(event){
          if(event.target.closest('button'))return;
          activeBlock=block;
          expandMobileStep(block,summary.dataset.mmStepSummary);
          updateGlobalProgress();
        });
        summary.addEventListener('keydown',function(event){
          if(event.key!=='Enter'&&event.key!==' ')return;
          event.preventDefault();
          activeBlock=block;
          expandMobileStep(block,summary.dataset.mmStepSummary);
          updateGlobalProgress();
        });
      });
    }

    function stepSection(block,key){
      return block.querySelector('[data-mm-step-section="'+key+'"]');
    }

    function firstIncompleteExtraColour(block){
      var groups=extraColourGroups(block);
      for(var i=0;i<groups.length;i++){
        var group=groups[i];
        if(!extraColourName(group)){
          var select=group.querySelector('[data-mm-extra-colour-select]');
          var other=group.querySelector('[data-mm-extra-colour-other]');
          return {
            target:(select&&select.value==='Other'&&other)?other:(select||group),
            label:'Choose the added garment colour'
          };
        }
        if(extraColourTotal(group)<=0){
          return {
            target:group.querySelector('[data-mm-extra-quantity-grid]')||group,
            label:'Enter quantities for the added colour'
          };
        }
      }
      return null;
    }

    function nextGarmentStep(block){
      var type=block.dataset.type||'';
      if(!type){
        return {target:block.querySelector('[data-role="type-grid"]'),label:'Choose garment type'};
      }

      if(type==='Other'){
        var otherDescription=block.querySelector('[data-role="other-description"]');
        var otherQty=block.querySelector('[data-role="other-qty"]');
        if(otherDescription && !otherDescription.value.trim()){
          return {target:otherDescription,label:'Tell us what item you need'};
        }
        if(otherQty && (parseInt(otherQty.value||'0',10)||0)<=0){
          return {target:otherQty,label:'Enter the quantity'};
        }
        return null;
      }

      var mode=block.dataset.mode||'';
      if(!mode){
        return {target:block.querySelector('[data-role="mode-grid"]'),label:'Choose how you want to select the garment'};
      }

      if(mode==='exact'){
        var garmentGrid=block.querySelector('[data-role="garment-grid"]');
        if(!selectedValue(garmentGrid)){
          return {target:garmentGrid,label:'Pick your garment'};
        }
        var colorSection=block.querySelector('[data-role="color-section"]');
        var colorGrid=block.querySelector('[data-role="color-grid"]');
        var colorRequired=colorSection && !colorSection.classList.contains('mm-hidden') && colorGrid && colorGrid.children.length>0;
        if(colorRequired && !selectedValue(colorGrid)){
          return {target:colorGrid,label:'Choose garment colour'};
        }
      }else if(mode==='lowest'||mode==='recommend'){
        if(!preferredComplete(block)){
          var preferredGrid=block.querySelector('[data-role="preferred-grid"]');
          var preferredValue=selectedValue(preferredGrid);
          var preferredOther=block.querySelector('[data-role="preferred-other-input"]');
          return {
            target:preferredValue==='Other' ? preferredOther : preferredGrid,
            label:preferredValue==='Other'?'Enter your preferred garment colour':'Choose a preferred garment colour'
          };
        }
      }

      var locationsGrid=block.querySelector('[data-role="locations-grid"]');
      if(!selectedValues(locationsGrid).length){
        return {target:locationsGrid,label:'Choose print locations'};
      }
      if(block.dataset.mmLocationsConfirmed!=='1'){
        return {target:block.querySelector('[data-mm-location-continue]'),label:'Continue to quantities'};
      }

      if(quantityTotal(block)<=0){
        return {target:block.querySelector('[data-role="quantity-grid"]'),label:'Enter garment quantities'};
      }

      var extraStep=firstIncompleteExtraColour(block);
      if(extraStep)return extraStep;

      return null;
    }

    function clearNextTarget(){
      if(nextTarget){
        nextTarget.classList.remove('mm-next-target','mm-next-target--pulse');
      }
      nextTarget=null;
      nextTargetAcknowledged=false;
    }

    function setNextStep(step){
      if(!step||!step.target){
        clearNextTarget();
        if(nextStepGuide)show(nextStepGuide,false);
        return;
      }

      if(nextTarget!==step.target){
        clearNextTarget();
        nextTarget=step.target;
      }

      if(nextStepText)nextStepText.textContent=step.label;
      if(nextStepGuide)show(nextStepGuide,true);
      nextTarget.classList.add('mm-next-target');
      if(!nextTargetAcknowledged)nextTarget.classList.add('mm-next-target--pulse');
    }

    function updateNextStepGuide(){
      var step=null;

      if(quoteStage==='details'){
        var required=detailsSection ? Array.from(detailsSection.querySelectorAll('input[required],textarea[required],select[required]')) : [];
        var nextRequired=required.find(function(field){return !field.disabled && !field.checkValidity();});
        step=nextRequired
          ? {target:nextRequired,label:'Complete your details'}
          : {target:flowReviewButton,label:'Review quote'};
        setNextStep(step);
        return;
      }

      if(quoteStage==='review'){
        setNextStep({target:submitButton,label:'Submit quote request'});
        return;
      }

      var blocks=Array.from(list.children);
      for(var i=0;i<blocks.length;i++){
        var editingColour=blocks[i].classList.contains('mm-garment-colour-editing');
        var state=progressState(blocks[i]);
        if(!state.complete){
          step=nextGarmentStep(blocks[i]);
          if(step)break;
        }else if(editingColour){
          step={target:blocks[i].querySelector('[data-mm-extra-colour].mm-extra-colour--active [data-mm-extra-colour-done]'),label:'Done with this colour'};
          break;
        }else if(!blocks[i].classList.contains('mm-garment-collapsed')){
          step={target:blocks[i].querySelector('[data-mm-finish-garment]'),label:'Done with this garment'};
          break;
        }
      }

      if(!step){
        var files=Array.isArray(form._mmSelectedFiles) ? form._mmSelectedFiles : (artworkInput ? Array.from(artworkInput.files||[]) : []);
        if(!files.length){
          step={target:(artworkSection&&artworkSection.querySelector('.mm-artwork-upload'))||artworkSection,label:'Attach your artwork'};
        }else{
          step={target:flowContinueButton,label:'Continue'};
        }
      }

      setNextStep(step);
    }

    function acknowledgeNextTarget(event){
      if(!nextTarget||!event.target||!nextTarget.contains(event.target))return;
      nextTargetAcknowledged=true;
      nextTarget.classList.remove('mm-next-target--pulse');
    }

    function jumpToNextTarget(){
      if(!nextTarget)return;
      nextTarget.scrollIntoView({behavior:'smooth',block:'center'});
      var focusable=nextTarget.matches('button,input,select,textarea')
        ? nextTarget
        : nextTarget.querySelector('input:not([type="hidden"]),select,textarea,button');
      if(focusable){
        setTimeout(function(){
          try{focusable.focus({preventScroll:true});}catch(_){focusable.focus();}
        },420);
      }
    }

    function resetCollapsedSteps(block,keys){
      (keys||['type','mode','garment','preferred','color']).forEach(function(key){
        var sec=stepSection(block,key);
        if(sec)sec.classList.remove('mm-step-collapsed');
      });
    }

    function collapseMobileStep(block,key,text){
      var sec=stepSection(block,key);
      if(!sec)return;
      var out=sec.querySelector('[data-mm-step-summary-text]');
      if(out)out.textContent=text||'Selected';
      sec.classList.add('mm-step-collapsed');
    }

    function hideDownstreamForEdit(block,key){
      var roles={
        type:['mode-section','garment-section','preferred-section','preferred-other','color-section','locations-section','details-section','other-section'],
        mode:['garment-section','preferred-section','preferred-other','color-section','locations-section','details-section'],
        garment:['color-section','locations-section','details-section'],
        preferred:['preferred-other','locations-section','details-section'],
        color:['locations-section','details-section']
      }[key]||[];
      roles.forEach(function(role){
        show(block.querySelector('[data-role="'+role+'"]'),false);
      });
    }

    function restoreExistingFlow(block){
      var type=block.dataset.type||'';
      var mode=block.dataset.mode||'';

      if(type==='Other'){
        show(block.querySelector('[data-role="other-section"]'),true);
        return;
      }

      if(!type)return;
      var modeSection=block.querySelector('[data-role="mode-section"]');
      if(modeSection&&modeOptions(type).length)show(modeSection,true);
      if(!mode)return;

      if(mode==='exact'){
        var garmentSection=block.querySelector('[data-role="garment-section"]');
        if(garmentSection)show(garmentSection,true);
        if(!block.dataset.garment)return;

        var colorSection=block.querySelector('[data-role="color-section"]');
        var colorGrid=block.querySelector('[data-role="color-grid"]');
        var hasColourChoices=!!(colorGrid&&colorGrid.children.length);
        if(colorSection&&hasColourChoices)show(colorSection,true);

        var colourReady=!hasColourChoices || !!selectedValue(colorGrid);
        if(colourReady)show(block.querySelector('[data-role="locations-section"]'),true);
      }else if(mode==='lowest'||mode==='recommend'){
        var preferredSection=block.querySelector('[data-role="preferred-section"]');
        if(preferredSection)show(preferredSection,true);
        var preferred=selectedValue(block.querySelector('[data-role="preferred-grid"]'));
        if(preferred==='Other'){
          var otherInput=block.querySelector('[data-role="preferred-other-input"]');
          show(block.querySelector('[data-role="preferred-other"]'),!otherInput.value.trim());
        }
        if(preferredComplete(block))show(block.querySelector('[data-role="locations-section"]'),true);
      }

      var locations=selectedValues(block.querySelector('[data-role="locations-grid"]'));
      var locationsConfirmed=block.dataset.mmLocationsConfirmed==='1';
      var locationContinueWrap=block.querySelector('[data-mm-location-continue-wrap]');
      if(locationContinueWrap)show(locationContinueWrap,locations.length>0&&!locationsConfirmed);
      show(block.querySelector('[data-role="details-section"]'),locations.length>0&&locationsConfirmed);
    }

    function expandMobileStep(block,key){
      var sec=stepSection(block,key);
      if(!sec)return;

      var previousKey=block.dataset.mmEditingStep||'';
      if(previousKey && previousKey!==key){
        var previousSection=stepSection(block,previousKey);
        if(previousSection)previousSection.classList.add('mm-step-collapsed');
      }

      block.dataset.mmEditingStep=key;
      hideDownstreamForEdit(block,key);
      sec.classList.remove('mm-step-collapsed');
      if(key==='preferred'){
        var selected=selectedValue(block.querySelector('[data-role="preferred-grid"]'));
        show(block.querySelector('[data-role="preferred-other"]'),selected==='Other');
      }
      frameQuoteTarget(sec,20);
    }

    function frameQuoteTarget(target,delay){
      if(!target)return;
      setTimeout(function(){
        if(!target.isConnected||target.classList.contains('mm-hidden'))return;
        var mobile=isMobileQuote();
        var rect=target.getBoundingClientRect();
        var view=(window.visualViewport&&window.visualViewport.height)||window.innerHeight;
        var top=quoteSafeTop(mobile)+(mobile?2:4);
        var bottom=view-(mobile?24:36);
        var available=bottom-top;
        if(available<180)return;

        var comfortBottom=top+available*(mobile?.78:.76);
        var desired=0;

        if(rect.height>=available*.78){
          // Large sections should expose their heading rather than trying to centre.
          if(rect.top<top||rect.bottom>bottom)desired=rect.top-top;
        }else if(rect.top<top){
          desired=rect.top-top;
        }else if(rect.bottom>comfortBottom){
          // Once the active section sinks into the bottom quarter, bring it back
          // into a comfortable working position with useful context above it.
          var focusCenter=top+available*(mobile?.56:.54);
          desired=(rect.top+rect.height/2)-focusCenter;
        }

        if(Math.abs(desired)>14){
          window.scrollBy({
            top:desired,
            behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'
          });
        }
      },typeof delay==='number'?delay:70);
    }

    function gentleAdvance(target,event){
      if(!target||!event||event.isTrusted!==true)return;
      frameQuoteTarget(target,85);
    }

    function syncQuantityEntered(input){
      if(!input)return;
      var entered=(parseInt(input.value||'0',10)||0)>0;
      var control=input.closest('.mm-qty-control');
      var cell=input.closest('.mm-qty');
      if(control)control.classList.toggle('is-entered',entered);
      if(cell)cell.classList.toggle('is-entered',entered);
    }

    function quantityTotal(block){
      var total=0;
      block.querySelectorAll('[data-role="qty"]').forEach(function(input){
        total+=(parseInt(input.value||'0',10)||0);
      });
      return total;
    }

    function updateQuantityTotal(block){
      var total=quantityTotal(block);
      var headingTotal=block.querySelector('[data-mm-quantity-heading-total]');
      if(headingTotal)headingTotal.textContent='Total: '+String(total);
      var el=block.querySelector('[data-role="quantity-total"]');
      if(el)el.textContent=String(total);
    }

    function preferredComplete(block){
      var value=selectedValue(block.querySelector('[data-role="preferred-grid"]'));
      if(!value)return false;
      if(value==='Other'){
        return !!block.querySelector('[data-role="preferred-other-input"]').value.trim();
      }
      return true;
    }

    function progressState(block){
      var type=block.dataset.type||'';
      var completed=0;
      var total=6;

      if(type==='Other'){
        total=3;
        if(type)completed++;
        if(block.querySelector('[data-role="other-description"]').value.trim())completed++;
        if((parseInt(block.querySelector('[data-role="other-qty"]').value||'0',10)||0)>0)completed++;
      }else{
        if(type)completed++;
        var mode=block.dataset.mode||'';
        if(mode)completed++;

        if(mode==='exact'){
          if(selectedValue(block.querySelector('[data-role="garment-grid"]')))completed++;
          var colorSection=block.querySelector('[data-role="color-section"]');
          var colorRequired=colorSection && !colorSection.classList.contains('mm-hidden') && block.querySelector('[data-role="color-grid"]').children.length>0;
          if(colorRequired){
            total=6;
            if(selectedValue(block.querySelector('[data-role="color-grid"]')))completed++;
          }else{
            total=5;
          }
        }else if(mode==='lowest'||mode==='recommend'){
          total=5;
          if(preferredComplete(block))completed++;
        }

        if(quantityTotal(block)>0 && extraColoursValid(block))completed++;
        if(selectedValues(block.querySelector('[data-role="locations-grid"]')).length && block.dataset.mmLocationsConfirmed==='1')completed++;
      }

      completed=Math.min(completed,total);
      return {completed:completed,total:total,complete:completed===total};
    }

    function readableSizeParts(parts){
      return (parts||[]).map(function(value){
        var text=String(value||'').trim();
        var match=text.match(/^(.+?)\s+(\d+)$/);
        return match ? match[1]+' × '+match[2] : text;
      }).filter(Boolean);
    }

    function garmentSummaryData(block,index){
      var state=progressState(block);
      var type=block.dataset.type||'Garment';
      var mode=block.dataset.mode||'';
      var primary=[];
      var secondary=[];
      var quantitySummary='';
      var locationSummary='';

      if(type==='Other'){
        var desc=block.querySelector('[data-role="other-description"]').value.trim();
        var col=block.querySelector('[data-role="other-colour"]').value.trim();
        primary.push(desc||'Other item');
        if(col)primary.push(col);
        var oq=parseInt(block.querySelector('[data-role="other-qty"]').value||'0',10)||0;
        if(oq)secondary.push('Qty '+oq);
      }else{
        primary.push(type);
        if(mode==='exact'){
          var gv=selectedValue(block.querySelector('[data-role="garment-grid"]'));
          var garment=(data.garments[type]||[]).find(function(x){return x.value===gv;});
          if(garment)primary.push(garment.label);
        }else if(mode==='lowest'||mode==='recommend'){
          primary.push(mode==='lowest'?'Lowest-cost option':'Recommend one for me');
          var preferred=primaryColourValue(block);
          if(preferred)secondary.push(preferred);
        }

        var breakdowns=colourBreakdowns(block);
        if(breakdowns.length){
          secondary=secondary.filter(function(x){return x!==preferred;});
          if(breakdowns.length===1){
            var oneSizes=readableSizeParts(breakdowns[0].sizes);
            quantitySummary=[breakdowns[0].colour].concat(oneSizes).join(' · ');
            secondary.push(quantitySummary);
          }else{
            quantitySummary=breakdowns.map(function(item){
              var sizes=readableSizeParts(item.sizes);
              return item.colour+(sizes.length?': '+sizes.join(', '):(item.total?' · '+item.total:''));
            }).join(' | ');
            secondary.push(quantitySummary);
          }
        }
        var locs=selectedValues(block.querySelector('[data-role="locations-grid"]'));
        if(locs.length){
          locationSummary=locs.join(' + ');
          secondary.push(locationSummary);
        }
      }

      return {
        title:'Garment '+index,
        complete:state.complete,
        completed:state.completed,
        total:state.total,
        line1:primary.filter(Boolean).join(' · '),
        line2:secondary.filter(Boolean).join(' · '),
        quantitySummary:quantitySummary,
        locationSummary:locationSummary
      };
    }

    function garmentPieceTotal(block){
      if(block.dataset.type==='Other'){
        return parseInt(block.querySelector('[data-role="other-qty"]')?.value||'0',10)||0;
      }
      return colourBreakdowns(block).reduce(function(sum,item){
        return sum+(item.total||0);
      },0);
    }

    function refreshCompactSummary(block){
      var blocks=Array.from(list.children);
      var index=Math.max(0,blocks.indexOf(block))+1;
      var info=garmentSummaryData(block,index);
      var compact=block.querySelector('[data-role="garment-compact"]');
      var title=block.querySelector('[data-role="garment-compact-title"]');
      var line1=block.querySelector('[data-role="garment-compact-line1"]');
      var line2=block.querySelector('[data-role="garment-compact-line2"]');
      if(title)title.textContent=(info.complete?'✓ ':'')+info.title;
      if(line1)line1.textContent=info.line1;
      if(line2)line2.textContent=info.line2;

      if(compact){
        var typeOption=(data.typeOptions||[]).find(function(option){
          return option.value===block.dataset.type;
        });
        var visual=compact.querySelector('[data-mm-compact-type-icon]');
        if(!visual){
          visual=document.createElement('span');
          visual.className='mm-garment-compact__type-icon';
          visual.setAttribute('data-mm-compact-type-icon','');
          var actions=compact.querySelector('.mm-garment-compact__actions');
          if(actions)compact.insertBefore(visual,actions);
          else compact.appendChild(visual);
        }

        var total=garmentPieceTotal(block);

        if(typeOption&&typeOption.image){
          visual.innerHTML=
            '<img src="'+esc(cdnThumb(typeOption.image,120))+'" alt="" aria-hidden="true">'+
            '<strong class="mm-garment-compact__qty" aria-label="'+total+' total items">×'+total+'</strong>';
          visual.classList.remove('mm-hidden');
        }else{
          visual.innerHTML='';
          visual.classList.add('mm-hidden');
        }
      }
    }

    function collapseGarmentBlock(block){
      if(!block||!progressState(block).complete)return false;
      refreshCompactSummary(block);
      block.classList.add('mm-garment-collapsed');
      return true;
    }

    function expandGarmentBlock(block,shouldScroll){
      if(!block)return;
      block.classList.remove('mm-garment-colour-editing');
      block.querySelectorAll('.mm-extra-colour--active').forEach(function(group){
        group.classList.remove('mm-extra-colour--active','mm-extra-colour--awaiting-colour');
      });
      if(quoteStage!=='build')setQuoteStage('build',false);
      Array.from(list.children).forEach(function(other){
        if(other!==block && progressState(other).complete)collapseGarmentBlock(other);
      });
      block.classList.remove('mm-garment-collapsed');
      activeBlock=block;
      updateGlobalProgress();
      if(shouldScroll){
        setTimeout(function(){
          if(isMobileQuote()){
            var rect=block.getBoundingClientRect();
            window.scrollBy({top:rect.top-118,behavior:'smooth'});
          }else{
            block.scrollIntoView({behavior:'smooth',block:'center'});
          }
        },20);
      }
    }

    function finalReviewContactHtml(){
      var first=mmFieldValue(form,'contact[First Name]');
      var last=mmFieldValue(form,'contact[Last Name]');
      var company=mmFieldValue(form,'contact[Company]');
      var email=mmFieldValue(form,'contact[email]');
      var address1=mmFieldValue(form,'contact[Address Line 1]');
      var address2=mmFieldValue(form,'contact[Address Line 2]');
      var city=mmFieldValue(form,'contact[City]');
      var region=mmFieldValue(form,'contact[State / Province]');
      var postal=mmFieldValue(form,'contact[Zip / Postal Code]');
      var country=mmFieldValue(form,'contact[Country]');
      var name=[first,last].filter(Boolean).join(' ');
      var address=[address1,address2,[city,region,postal].filter(Boolean).join(' '),country].filter(Boolean).join(' · ');
      return '<div class="mm-final-review__copy">'
        +'<strong>'+esc(name||'Your details not complete yet')+'</strong>'
        +(company?'<span>'+esc(company)+'</span>':'')
        +(email?'<span>'+esc(email)+'</span>':'')
        +(address?'<span>'+esc(address)+'</span>':'')
        +'</div>';
    }

    function finalReviewArtworkHtml(files){
      var previewable=(files||[]).filter(function(file){
        return /^image\//i.test(file.type||'') || /\.(?:jpe?g|png|svg)$/i.test(file.name||'');
      }).slice(0,3);

      form._mmArtworkPreviewUrls=form._mmArtworkPreviewUrls||new Map();
      var thumbs=previewable.map(function(file){
        var key=fileSignature([file]);
        var url=form._mmArtworkPreviewUrls.get(key);
        if(!url && window.URL && URL.createObjectURL){
          url=URL.createObjectURL(file);
          form._mmArtworkPreviewUrls.set(key,url);
        }
        return url
          ? '<img class="mm-final-review__artwork-thumb" src="'+esc(url)+'" alt="Artwork preview">'
          : '';
      }).join('');

      var copy=files.length
        ? files.length+' file'+(files.length===1?'':'s')+' attached'
        : 'No artwork attached yet';

      return '<div class="mm-final-review__artwork">'
        +(thumbs?'<div class="mm-final-review__artwork-thumbs">'+thumbs+'</div>':'')
        +'<div class="mm-final-review__simple">'+esc(copy)+'</div>'
        +'</div>';
    }

    function renderFinalReview(){
      if(!finalReview)return;
      var blocks=Array.from(list.children);
      var files=Array.isArray(form._mmSelectedFiles)?form._mmSelectedFiles:[];
      var notes=mmFieldValue(form,'contact[Questions / Special Requests]');

      var orderTotal=blocks.reduce(function(sum,block){return sum+garmentPieceTotal(block);},0);
      var garmentHtml=blocks.map(function(block,index){
        var info=garmentSummaryData(block,index+1);
        var reviewLine2=info.quantitySummary || info.line2;
        return '<div class="mm-final-review__item '+(info.complete?'is-complete':'is-incomplete')+'">'
          +'<div class="mm-final-review__copy">'
          +'<strong>'+(info.complete?'✓ ':'')+esc(info.title)+(info.complete?'':' · In progress')+'</strong>'
          +(info.line1?'<span>'+esc(info.line1)+'</span>':'')
          +(reviewLine2?'<span>'+esc(reviewLine2)+'</span>':'')
          +(info.locationSummary?'<span class="mm-final-review__locations">'+esc(info.locationSummary)+'</span>':'')
          +'</div>'
          +'<div class="mm-final-review__actions">'
          +'<button type="button" data-mm-final-edit-garment="'+index+'">Edit</button>'
          +'<button type="button" class="mm-review-remove" data-mm-final-remove-garment="'+index+'">Remove</button>'
          +'</div>'
          +'</div>';
      }).join('');

      var notesHtml=notes
        ? '<div class="mm-final-review__group">'
            +'<div class="mm-final-review__head"><strong>ANYTHING ELSE?</strong><button type="button" data-mm-final-edit-notes>Edit</button></div>'
            +'<div class="mm-final-review__simple">'+esc(notes)+'</div>'
          +'</div>'
        : '';

      finalReview.innerHTML=
        '<div class="mm-final-review__group">'
          +'<div class="mm-final-review__head"><strong>ORDER</strong><span class="mm-final-review__head-meta">Total: '+orderTotal+'</span></div>'
          +(garmentHtml||'<div class="mm-final-review__empty">No garments added yet.</div>')
        +'</div>'
        +'<div class="mm-final-review__group">'
          +'<div class="mm-final-review__head"><strong>ARTWORK</strong><button type="button" data-mm-final-edit-artwork>Edit</button></div>'
          +finalReviewArtworkHtml(files)
        +'</div>'
        +'<div class="mm-final-review__group">'
          +'<div class="mm-final-review__head"><strong>YOUR DETAILS</strong><button type="button" data-mm-final-edit-details>Edit</button></div>'
          +finalReviewContactHtml()
        +'</div>'
        +notesHtml;
    }

    function scrollToSection(target){
      if(!target)return;
      target.scrollIntoView({behavior:'smooth',block:'start'});
    }

    function updateGlobalProgress(){
      var blocks=Array.from(list.children);
      if(!blocks.length)return;

      if(!activeBlock || !list.contains(activeBlock)){
        activeBlock=blocks[blocks.length-1];
      }

      var completeCount=blocks.filter(function(b){return progressState(b).complete;}).length;
      var activeIndex=blocks.indexOf(activeBlock);
      if(activeIndex<0){activeIndex=blocks.length-1;activeBlock=blocks[activeIndex];}
      var state=progressState(activeBlock);
      var pct=state.total?Math.round((state.completed/state.total)*100):0;

      if(garmentStatusText){
        if(completeCount===blocks.length){
          garmentStatusText.textContent='✓ '+completeCount+' garment'+(completeCount===1?'':'s')+' complete';
        }else if(blocks.length>1){
          garmentStatusText.textContent=(completeCount?'✓ '+completeCount+' complete · ':'')+'Garment '+(activeIndex+1)+': '+state.completed+'/'+state.total;
        }else{
          garmentStatusText.textContent='Garment 1 · '+state.completed+'/'+state.total+' complete';
        }
      }

      if(garmentStatusFill)garmentStatusFill.style.width=pct+'%';
      if(reviewBtn)reviewBtn.hidden=!(blocks.length>1 || completeCount===blocks.length);
      if(addGarmentWrap)show(addGarmentWrap,completeCount===blocks.length&&blocks.length>0);
      refreshFlowState();
      updateNextStepGuide();
      renderFinalReview();
    }

    function updateProgress(block){
      var state=progressState(block);
      var textEl=block.querySelector('[data-role="progress-text"]');
      var fill=block.querySelector('[data-role="progress-fill"]');
      var garmentName=block.querySelector('[data-role="garment-number"]')?.textContent||'Garment';
      if(textEl)textEl.textContent=state.complete
        ? garmentName+' · Complete ✓'
        : garmentName+' · '+state.completed+'/'+state.total+' complete';
      if(fill)fill.style.width=(state.total?Math.round((state.completed/state.total)*100):0)+'%';
      block.classList.toggle('is-garment-complete',state.complete);
      var finishButton=block.querySelector('[data-mm-finish-garment]');
      if(finishButton)show(finishButton,state.complete&&!block.classList.contains('mm-garment-collapsed'));
      block.dataset.mmComplete=state.complete?'1':'0';
      block.dataset.mmProgressCompleted=String(state.completed);
      block.dataset.mmProgressTotal=String(state.total);
      syncAddColourButton(block);
      refreshCompactSummary(block);
      updateGlobalProgress();
    }

    function renderReview(){
      if(!reviewList)return;
      var blocks=Array.from(list.children);
      reviewList.innerHTML=blocks.map(function(block,i){
        var info=garmentSummaryData(block,i+1);
        return '<div class="mm-garment-review__item '+(info.complete?'is-complete':'is-incomplete')+'" data-mm-review-index="'+i+'">'+
          '<div class="mm-garment-review__item-copy">'+
            '<strong>'+(info.complete?'✓ ':'')+esc(info.title)+(info.complete?'':' · In progress')+'</strong>'+
            (info.line1?'<span>'+esc(info.line1)+'</span>':'')+
            (info.line2?'<span>'+esc(info.line2)+'</span>':'')+
          '</div>'+
          '<div class="mm-garment-review__actions">'+
            '<button type="button" data-mm-review-edit="'+i+'">Edit</button>'+
            '<button type="button" class="mm-review-remove" data-mm-review-remove="'+i+'">Remove</button>'+
          '</div>'+
        '</div>';
      }).join('');
    }

    function openReview(){
      if(!review)return;
      renderReview();
      previousBodyOverflow=document.body.style.overflow;
      document.body.style.overflow='hidden';
      show(review,true);
      review.setAttribute('aria-hidden','false');
    }

    function closeReview(){
      if(!review)return;
      show(review,false);
      review.setAttribute('aria-hidden','true');
      document.body.style.overflow=previousBodyOverflow;
    }

    function removeGarmentBlock(block,fromReview){
      if(!block)return;
      var wasActive=activeBlock===block;
      block.remove();

      if(!list.children.length){
        addGarment(null);
        activeBlock=list.firstElementChild||null;
      }else if(wasActive){
        activeBlock=list.lastElementChild||null;
      }

      renumber();
      updateGlobalProgress();

      if(fromReview){
        renderReview();
      }

      if(activeBlock&&list.children.length===1&&!activeBlock.dataset.type){
        var start=activeBlock.querySelector('[data-role="type-grid"]')||activeBlock;
        markNewSection(activeBlock,'');
        window.setTimeout(function(){
          if(fromReview)closeReview();
          mmFocusAndScroll(start);
        },40);
      }
    }

    function bindAcceleratingQuantityButton(button,change){
      if(!button||button.dataset.mmHoldBound==='1')return;
      button.dataset.mmHoldBound='1';
      var timer=null,holding=false,startedAt=0;
      var lastPointerType='',touchMoved=false,touchStartX=0,touchStartY=0;
      function stop(){
        holding=false;
        if(timer){clearTimeout(timer);timer=null;}
      }
      function repeat(){
        if(!holding)return;
        var elapsed=performance.now()-startedAt;
        var amount=elapsed>=3200?5:(elapsed>=2200?2:1);
        var delay=elapsed>=3200?42:(elapsed>=2200?52:(elapsed>=1200?72:120));
        change(amount);
        timer=setTimeout(repeat,delay);
      }
      button.addEventListener('pointerdown',function(event){
        if(event.button!==undefined&&event.button!==0)return;
        stop();
        lastPointerType=event.pointerType||'mouse';
        if(lastPointerType==='touch'||lastPointerType==='pen'){
          // Allow the browser to recognize and perform vertical scrolling.
          // A touch only changes the value on the resulting deliberate click.
          touchMoved=false;touchStartX=event.clientX;touchStartY=event.clientY;
          return;
        }
        event.preventDefault();
        holding=true;startedAt=performance.now();
        change(1);
        try{button.setPointerCapture(event.pointerId);}catch(_){}
        timer=setTimeout(repeat,380);
      });
      button.addEventListener('pointermove',function(event){
        if(lastPointerType!=='touch'&&lastPointerType!=='pen')return;
        if(Math.abs(event.clientY-touchStartY)>9||Math.abs(event.clientX-touchStartX)>9)touchMoved=true;
      });
      button.addEventListener('pointerup',stop);
      button.addEventListener('pointercancel',function(){touchMoved=true;stop();});
      button.addEventListener('lostpointercapture',stop);
      button.addEventListener('contextmenu',function(event){event.preventDefault();});
      button.addEventListener('click',function(event){
        if(event.detail===0){change(1);return;} // keyboard / assistive click
        if((lastPointerType==='touch'||lastPointerType==='pen')&&!touchMoved)change(1);
        // Mouse was already counted on pointerdown, without duplicating the click.
      });
    }

    function wireQuantities(block){
      var box=block.querySelector('[data-role="quantity-grid"]');
      if(!box)return;
      box.querySelectorAll('.mm-qty').forEach(function(cell){
        var input=cell.querySelector('[data-role="qty"]');
        var minus=cell.querySelector('[data-mm-qty-minus]');
        var plus=cell.querySelector('[data-mm-qty-plus]');

        function setQty(value){
          var n=Math.max(0,Math.round(Number(value)||0));
          input.value=n>0?String(n):'';
          syncQuantityEntered(input);
          updateQuantityTotal(block);
          updateProgress(block);
        }

        function changeQty(direction,amount){
          var current=parseInt(input.value||'0',10)||0;
          setQty(current+(direction*amount));
        }
        bindAcceleratingQuantityButton(minus,function(amount){changeQty(-1,amount);});
        bindAcceleratingQuantityButton(plus,function(amount){changeQty(1,amount);});
        input.addEventListener('input',function(){
          if(input.value!=='' && Number(input.value)<0)input.value='';
          syncQuantityEntered(input);
          updateQuantityTotal(block);
          updateProgress(block);
        });
        input.addEventListener('blur',function(){
          if((parseInt(input.value||'0',10)||0)<=0)input.value='';
          syncQuantityEntered(input);
          updateQuantityTotal(block);
        });
        input.addEventListener('focus',function(){if(input.value==='0')input.select();});
      });
      updateQuantityTotal(block);
      updateProgress(block);
    }

    function additionalColourOptions(block){
      var used=new Set(
        colourBreakdowns(block)
          .map(function(item){return String(item.colour||'').trim().toLowerCase();})
          .filter(Boolean)
      );
      var mode=block.dataset.mode||'';
      if(mode==='exact'){
        var type=block.dataset.type||'';
        var garment=(data.garments[type]||[]).find(function(g){return g.value===block.dataset.garment;});
        return (garment&&garment.colors||[]).map(function(c){
          return {
            label:c.label||c.value,
            value:c.value||c.label,
            image:c.image||''
          };
        }).filter(function(c){
          return !used.has(String(c.value||'').trim().toLowerCase());
        });
      }

      var representative=representativeGarment(data,block.dataset.type||'');
      return [
        {label:'Black',value:'Black',image:colourImage(representative,'Black')},
        {label:'White',value:'White',image:colourImage(representative,'White')},
        {label:'Other',value:'Other',image:MM_SWATCH_ICON}
      ].filter(function(c){
        return c.value==='Other' || !used.has(String(c.value).toLowerCase());
      });
    }

    function markNewSection(target,message){
      if(!target)return;
      var existing=target.querySelector('.mm-new-section-note');
      if(existing)existing.remove();

      target.classList.add('mm-new-section');
      var note=null;
      if(message){
        note=document.createElement('div');
        note.className='mm-new-section-note';
        note.setAttribute('role','status');
        note.textContent=message;
        target.insertBefore(note,target.firstChild);
      }

      function clearCue(){
        if(note&&note.isConnected)note.remove();
        target.classList.remove('mm-new-section');
        target.removeEventListener('input',clearCue,true);
        target.removeEventListener('change',clearCue,true);
        target.removeEventListener('click',clearCue,true);
      }

      target.addEventListener('input',clearCue,true);
      target.addEventListener('change',clearCue,true);
      target.addEventListener('click',clearCue,true);
      window.setTimeout(function(){target.classList.remove('mm-new-section');},2200);
    }

    function syncPrimaryQuantityTitle(block){
      var title=block.querySelector('[data-role="quantity-title"]');
      if(!title)return;
      var colour=primaryColourValue(block);
      title.innerHTML=
        '<span>Quantities'+(colour?': '+esc(colour):'')+'</span>'+
        '<strong class="mm-quantity-heading-total" data-mm-quantity-heading-total>Total: '+String(quantityTotal(block))+'</strong>';
    }

    function syncAddColourButton(block){
      var btn=block.querySelector('[data-mm-add-colour]');
      if(!btn)return;
      var help=block.querySelector('.mm-add-colour-help');
      var locations=selectedValues(block.querySelector('[data-role="locations-grid"]'));
      var ready=block.dataset.type && block.dataset.type!=='Other' && !!primaryColourValue(block) && locations.length>0 && quantityTotal(block)>0;
      var count=extraColourGroups(block).length;
      var visible=ready&&count<3;
      show(btn,visible);
      if(help)show(help,visible);
    }

    function refreshExtraColourNumbers(block){
      extraColourGroups(block).forEach(function(group,index){
        var title=group.querySelector('[data-mm-extra-title]');
        if(title)title.textContent=group.classList.contains('mm-extra-colour--active')?'New Colour':'Colour '+(index+2);
      });
    }

    function updateExtraColourTotal(block,group){
      var total=extraColourTotal(group);
      var totalEl=group.querySelector('[data-mm-extra-heading-total]');
      var colourEl=group.querySelector('[data-mm-extra-heading-colour]');
      if(totalEl)totalEl.textContent='Total: '+String(total);
      if(colourEl)colourEl.textContent=extraColourName(group)||'';
      updateProgress(block);
    }

    function setExtraQty(block,group,input,value){
      var n=Math.max(0,Math.round(Number(value)||0));
      input.value=n>0?String(n):'';
      syncQuantityEntered(input);
      updateExtraColourTotal(block,group);
      if(group&&group._mmSyncMiniColourFlow)group._mmSyncMiniColourFlow();
    }

    function extraQuantityMarkup(block){
      var sizes=block._mmSizes&&block._mmSizes.length?block._mmSizes:['S','M','L','XL','2XL','3XL'];
      return sizes.map(function(size){
        return '<div class="mm-qty"><label>'+esc(size)+'</label>'+
          '<div class="mm-qty-control">'+
            '<button type="button" class="mm-qty-button" data-mm-qty-minus aria-label="Decrease '+esc(size)+' quantity">−</button>'+
            '<input class="mm-input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="off" value="" placeholder="0" data-role="qty-extra" data-size="'+esc(size)+'" aria-label="'+esc(size)+' quantity">'+
            '<button type="button" class="mm-qty-button" data-mm-qty-plus aria-label="Increase '+esc(size)+' quantity">+</button>'+
          '</div></div>';
      }).join('');
    }

    function addExtraColour(block){
      var wrap=block.querySelector('[data-role="extra-colours"]');
      if(!wrap||extraColourGroups(block).length>=3)return null;
      var options=additionalColourOptions(block);
      var group=document.createElement('div');
      group.className='mm-extra-colour';
      group.setAttribute('data-mm-extra-colour','');
      var colourName='mm-extra-colour-choice-'+block.dataset.index+'-'+(extraColourGroups(block).length+1);
      group.innerHTML=
        '<div class="mm-extra-colour__head">'+
          '<strong data-mm-extra-title>Colour</strong>'+
          '<button type="button" data-mm-remove-extra-colour>Remove</button>'+
        '</div>'+
        '<div class="mm-field">'+
          '<div class="mm-choice-grid mm-colors" data-mm-extra-colour-grid>'+
            options.map(function(o){return choiceCard(o,colourName,'radio',220,'eager');}).join('')+
          '</div>'+
          '<input type="hidden" data-mm-extra-colour-select value="">'+
          '<input class="mm-input mm-hidden" type="text" data-mm-extra-colour-other placeholder="e.g. Burgundy, Forest Green">'+
        '</div>'+
        '<button type="button" class="mm-extra-colour-summary mm-hidden" data-mm-extra-colour-summary></button>'+
        '<div class="mm-extra-quantity-heading" data-mm-extra-quantity-heading>'+
          '<span>Quantities: <span data-mm-extra-heading-colour></span></span>'+
          '<strong data-mm-extra-heading-total>Total: 0</strong>'+
        '</div>'+
        '<div class="mm-quantity-grid" data-mm-extra-quantity-grid data-mm-qty-cols="'+quantityColumnCount((block._mmSizes||[]).length)+'">'+extraQuantityMarkup(block)+'</div>';
      wrap.appendChild(group);

      group.querySelectorAll('.mm-qty').forEach(function(cell){
        var input=cell.querySelector('[data-role="qty-extra"]');
        var minus=cell.querySelector('[data-mm-qty-minus]');
        var plus=cell.querySelector('[data-mm-qty-plus]');
        function changeExtra(direction,amount){
          var current=parseInt(input.value||'0',10)||0;
          setExtraQty(block,group,input,current+(direction*amount));
        }
        bindAcceleratingQuantityButton(minus,function(amount){changeExtra(-1,amount);});
        bindAcceleratingQuantityButton(plus,function(amount){changeExtra(1,amount);});
      });

      var extraGrid=group.querySelector('[data-mm-extra-colour-grid]');
      var extraValue=group.querySelector('[data-mm-extra-colour-select]');
      if(extraGrid&&extraValue){
        bindChoiceGrid(extraGrid,function(input,event){
          extraValue.value=input.value;
          if(input.value!=='Other'){
            group.classList.remove('mm-extra-colour--editing-choice');
          }
          extraValue.dispatchEvent(new Event('change',{bubbles:true}));
          if(event&&event.isTrusted){
            var other=group.querySelector('[data-mm-extra-colour-other]');
            if(input.value==='Other'){
              setTimeout(function(){other.focus();},40);
            }
          }
        });
      }

      refreshExtraColourNumbers(block);
      syncAddColourButton(block);
      updateProgress(block);

      markNewSection(group,'');
      var select=group.querySelector('[data-mm-extra-colour-select]');
      window.setTimeout(function(){
        mmFocusAndScroll(select||group);
      },40);
      return group;
    }

    function fillTypeGrid(block){
      var box=block.querySelector('[data-role="type-grid"]');
      box.innerHTML=data.typeOptions.map(function(o){return choiceCard(o,'mm-type-'+block.dataset.index,'radio',240,'eager');}).join('');
      bindChoiceGrid(box,function(input,event){handleType(block,input.value,event);});
    }

    function modeOptions(type){
      var noun={
        'T-Shirt':'T-shirt',
        'Hoodie':'hoodie',
        'Tank Top':'tank top',
        'Sweatshirt':'sweatshirt'
      }[type];
      if(!noun)return [];
      return [
        {label:'Exact garment',value:'exact'},
        {label:'Lowest cost',value:'lowest'},
        {label:'Recommend one',value:'recommend'}
      ];
    }

    function renderMode(block,type){
      var sec=block.querySelector('[data-role="mode-section"]');
      var box=block.querySelector('[data-role="mode-grid"]');
      var opts=modeOptions(type);
      if(!opts.length){show(sec,false);return;}
      box.innerHTML=opts.map(function(o){
        return '<label class="mm-radio"><input type="radio" name="mm-mode-'+block.dataset.index+'" value="'+o.value+'"><span>'+esc(o.label)+'</span></label>';
      }).join('');
      var modeReselect=null;
      var modeWasChecked=false;
      box.addEventListener('pointerdown',function(e){
          var row=e.target.closest('.mm-radio');
        var input=row&&row.querySelector('input[type="radio"]');
        modeReselect=input||null;
        modeWasChecked=!!(input&&input.checked);
      });
      box.addEventListener('pointerup',function(e){
        if(!modeReselect||!modeWasChecked)return;
        var input=modeReselect;
        modeReselect=null;
        modeWasChecked=false;
        if(input.checked)handleMode(block,input.value,e);
      });
      box.addEventListener('change',function(e){
        if(e.target.matches('input')) handleMode(block,e.target.value,e);
      });
      show(sec,true);
    }

    function renderGarments(block,type){
      var sec=block.querySelector('[data-role="garment-section"]');
      var box=block.querySelector('[data-role="garment-grid"]');
      var opts=(data.garments[type]||[]).map(function(o){
        return Object.assign({},o,{infoUrl:garmentPricingUrl(data,type,o)});
      });
      var html=opts.map(function(o){
        return choiceCard(o,'mm-garment-'+block.dataset.index,'radio',480,'eager');
      }).join('');
      revealGridWhenReady(sec,box,opts,480,html);
      bindChoiceGrid(box,function(input,event){handleGarment(block,type,input.value,event);});
    }

    function renderPreferred(block,type){
      var sec=block.querySelector('[data-role="preferred-section"]');
      var box=block.querySelector('[data-role="preferred-grid"]');
      show(sec,true);
      var garment=representativeGarment(data,type);
      var opts=[
        {label:'Black',value:'Black',image:colourImage(garment,'Black')},
        {label:'White',value:'White',image:colourImage(garment,'White')},
        {label:'Other',value:'Other',image:MM_SWATCH_ICON}
      ];

      var html=opts.map(function(o){
        return choiceCard(o,'mm-preferred-'+block.dataset.index,'radio',300,'eager');
      }).join('');
      revealGridWhenReady(sec,box,opts,300,html,true);
      bindChoiceGrid(box,function(input,event){
        var otherWrap=block.querySelector('[data-role="preferred-other"]');
        var otherInput=block.querySelector('[data-role="preferred-other-input"]');
        var locations=block.querySelector('[data-role="locations-section"]');
        show(otherWrap,input.value==='Other');
        if(input.value==='Other'){
          stepSection(block,'preferred')?.classList.remove('mm-step-collapsed');
          show(locations,!!otherInput.value.trim());
          if(event&&event.isTrusted)setTimeout(function(){otherInput.focus();},60);
        }else{
          collapseMobileStep(block,'preferred',input.value);
          show(locations,true);
          if(selectedValues(block.querySelector('[data-role="locations-grid"]')).length || quantityTotal(block)>0){
            show(block.querySelector('[data-role="details-section"]'),true);
          }
          delete block.dataset.mmEditingStep;
          gentleAdvance(locations,event);
        }
        syncPrimaryQuantityTitle(block);
        syncAddColourButton(block);
        updateProgress(block);
      });
      var otherInput=block.querySelector('[data-role="preferred-other-input"]');
      otherInput.oninput=function(event){
        var hasColour=!!otherInput.value.trim();
        show(block.querySelector('[data-role="locations-section"]'),hasColour);
        collapseMobileStep(block,'preferred',hasColour?otherInput.value.trim():'');
        syncPrimaryQuantityTitle(block);
        syncAddColourButton(block);
        updateProgress(block);
        if(hasColour)gentleAdvance(block.querySelector('[data-role="locations-section"]'),event);
      };
      otherInput.onblur=function(event){
        if(selectedValue(box)==='Other' && otherInput.value.trim()){
          collapseMobileStep(block,'preferred',otherInput.value.trim());
          show(block.querySelector('[data-role="preferred-other"]'),false);
          show(block.querySelector('[data-role="locations-section"]'),true);
          gentleAdvance(block.querySelector('[data-role="locations-section"]'),event);
          syncPrimaryQuantityTitle(block);
          syncAddColourButton(block);
          updateProgress(block);
        }
      };
      show(block.querySelector('[data-role="preferred-other"]'),false);
    }

    function renderColors(block,garment){
      var sec=block.querySelector('[data-role="color-section"]');
      var box=block.querySelector('[data-role="color-grid"]');
      show(sec,true);
      var opts=garment && garment.colors || [];
      if(!opts.length){box.innerHTML='';show(sec,false);return;}
      var html=opts.map(function(o){return choiceCard(o,'mm-color-'+block.dataset.index,'radio',220,'eager');}).join('');
      bindChoiceGrid(box,function(input,event){
        collapseMobileStep(block,'color',input.value);
        show(block.querySelector('[data-role="locations-section"]'),true);
        if(selectedValues(block.querySelector('[data-role="locations-grid"]')).length || quantityTotal(block)>0){
          show(block.querySelector('[data-role="details-section"]'),true);
        }
        delete block.dataset.mmEditingStep;
        syncPrimaryQuantityTitle(block);
        syncAddColourButton(block);
        updateProgress(block);
        gentleAdvance(block.querySelector('[data-role="locations-section"]'),event);
      });
      var title=sec.querySelector('[data-role="color-title"]');
      if(title) title.textContent='Colour';
      revealGridWhenReady(sec,box,opts,220,html);
    }

    function renderLocations(block,type,revealNow){
      var sec=block.querySelector('[data-role="locations-section"]');
      var box=block.querySelector('[data-role="locations-grid"]');
      var continueWrap=block.querySelector('[data-mm-location-continue-wrap]');
      var opts=data.printLocations[type]||[];
      if(!opts.length){
        box.innerHTML='';
        delete block.dataset.mmLocationsConfirmed;
        if(continueWrap)show(continueWrap,false);
        show(sec,false);
        return;
      }
      if(continueWrap)show(continueWrap,false);
      var html=opts.map(function(o){return choiceCard(o,'mm-location-'+block.dataset.index,'checkbox',300,'eager');}).join('');

      function applyLocationRules(input,event){
        var help=block.querySelector('[data-role="locations-help"]');
        var frontValues=['Right Chest','Left Chest','Full Front'];
        var hadSelection=selectedValues(box).length>0;

        if(input.checked && frontValues.indexOf(input.value)!==-1){
          box.querySelectorAll('input').forEach(function(other){
            if(other!==input && other.checked && frontValues.indexOf(other.value)!==-1){
              other.checked=false;
              var otherCard=other.closest('.mm-choice');
              if(otherCard)otherCard.classList.remove('is-selected');
            }
          });
        }

        var selected=selectedValues(box);
        if(input.checked && selected.length>2){
          input.checked=false;
          var card=input.closest('.mm-choice');
          if(card)card.classList.remove('is-selected');
          if(help){
            help.textContent='Choose one front location, plus Back if needed.';
            help.classList.add('mm-help-attention');
            setTimeout(function(){help.classList.remove('mm-help-attention');},900);
          }
        }else if(help){
          help.textContent='Choose one front location, plus Back if needed.';
        }

        box.querySelectorAll('.mm-choice').forEach(function(card){
          card.classList.toggle('is-selected',!!card.querySelector('input:checked'));
        });
        selected=selectedValues(box);
        delete block.dataset.mmLocationsConfirmed;
        var details=block.querySelector('[data-role="details-section"]');
        show(details,false);
        if(continueWrap)show(continueWrap,selected.length>0);
        updateProgress(block);
      }

      // Use the browser's native label/checkbox interaction for print locations.
      // The previous mobile pointer-up toggle duplicated the native control and
      // could swallow taps in Safari. Native labels already suppress clicks after
      // a real scroll gesture, so location selection stays reliable and scrollable.
      bindChoiceGrid(box,function(input,event){applyLocationRules(input,event);});

      revealGridWhenReady(sec,box,opts,300,html,revealNow!==false);
      box.style.touchAction='pan-y';
      box.querySelectorAll('.mm-choice').forEach(function(card){
        card.style.touchAction='pan-y';
      });
    }

    function clearDownstream(block){
      delete block.dataset.mmLocationsConfirmed;
      var locationContinueWrap=block.querySelector('[data-mm-location-continue-wrap]');
      if(locationContinueWrap)show(locationContinueWrap,false);
      ['mode-section','garment-section','preferred-section','preferred-other','color-section','details-section','locations-section','other-section'].forEach(function(r){show(block.querySelector('[data-role="'+r+'"]'),false);});
      block.querySelector('[data-role="garment-grid"]').innerHTML='';
      block.querySelector('[data-role="color-grid"]').innerHTML='';
      block.querySelector('[data-role="locations-grid"]').innerHTML='';
      block.querySelector('[data-role="preferred-grid"]').innerHTML='';
      var extra=block.querySelector('[data-role="extra-colours"]');
      if(extra)extra.innerHTML='';
      syncPrimaryQuantityTitle(block);
      syncAddColourButton(block);
    }

    function showCoreDetails(block,type,sizes,note){
      delete block.dataset.mmLocationsConfirmed;
      var locationContinueWrap=block.querySelector('[data-mm-location-continue-wrap]');
      if(locationContinueWrap)show(locationContinueWrap,false);
      var extra=block.querySelector('[data-role="extra-colours"]');
      if(extra)extra.innerHTML='';
      renderQuantities(block,sizes,note);
      wireQuantities(block);
      syncPrimaryQuantityTitle(block);
      syncAddColourButton(block);
      show(block.querySelector('[data-role="details-section"]'),false);
      renderLocations(block,type,false);
      updateProgress(block);
    }

    function handleType(block,type,event){
      var editingSameType=block.dataset.mmEditingStep==='type' && block.dataset.type===type;
      if(editingSameType){
        delete block.dataset.mmEditingStep;
        collapseMobileStep(block,'type',type);
        restoreExistingFlow(block);
        updateProgress(block);
        return;
      }

      delete block.dataset.mmEditingStep;
      clearDownstream(block);
      resetCollapsedSteps(block,['mode','garment','preferred','color']);
      block.dataset.type=type;
      block.dataset.mode='';
      block.dataset.garment='';
      collapseMobileStep(block,'type',type);

      if(type==='Other'){
        show(block.querySelector('[data-role="other-section"]'),true);
        var desc=block.querySelector('[data-role="other-description"]');
        var qty=block.querySelector('[data-role="other-qty"]');
        desc.oninput=function(){updateProgress(block);};
        qty.oninput=function(){updateProgress(block);};
        updateProgress(block);
        gentleAdvance(block.querySelector('[data-role="other-section"]'),event);
        return;
      }

      preloadGarmentChoices(data,type);
      renderMode(block,type);
      updateProgress(block);
      if(modeOptions(type).length){
        gentleAdvance(block.querySelector('[data-role="mode-section"]'),event);
        return;
      }
      block.dataset.mode='exact';
      renderGarments(block,type);
      gentleAdvance(block.querySelector('[data-role="garment-section"]'),event);
    }

    function handleMode(block,mode,event){
      var editingSameMode=block.dataset.mmEditingStep==='mode' && block.dataset.mode===mode;
      if(editingSameMode){
        delete block.dataset.mmEditingStep;
        var sameOpt=modeOptions(block.dataset.type).find(function(x){return x.value===mode;});
        collapseMobileStep(block,'mode',(sameOpt&&sameOpt.label?sameOpt.label:mode));
        restoreExistingFlow(block);
        updateProgress(block);
        return;
      }

      delete block.dataset.mmEditingStep;
      block.dataset.mode=mode;
      resetCollapsedSteps(block,['garment','preferred','color']);
      show(block.querySelector('[data-role="garment-section"]'),false);
      show(block.querySelector('[data-role="preferred-section"]'),false);
      show(block.querySelector('[data-role="preferred-other"]'),false);
      show(block.querySelector('[data-role="color-section"]'),false);
      show(block.querySelector('[data-role="details-section"]'),false);
      show(block.querySelector('[data-role="locations-section"]'),false);

      var opt=modeOptions(block.dataset.type).find(function(x){return x.value===mode;});
      collapseMobileStep(block,'mode',(opt&&opt.label?opt.label:mode));

      if(mode==='exact'){
        renderGarments(block,block.dataset.type);
        updateProgress(block);
        gentleAdvance(block.querySelector('[data-role="garment-section"]'),event);
      }else{
        var representative=representativeGarment(data,block.dataset.type);
        renderPreferred(block,block.dataset.type);
        showCoreDetails(
          block,
          block.dataset.type,
          combinedCategorySizes(data,block.dataset.type),
          ''
        );
        updateProgress(block);
        gentleAdvance(block.querySelector('[data-role="preferred-section"]'),event);
      }
    }

    function handleGarment(block,type,value,event){
      var editingSameGarment=block.dataset.mmEditingStep==='garment' && block.dataset.garment===value;
      if(editingSameGarment){
        delete block.dataset.mmEditingStep;
        var sameGarment=(data.garments[type]||[]).find(function(g){return g.value===value;});
        collapseMobileStep(block,'garment',(sameGarment&&sameGarment.label?sameGarment.label:value));
        restoreExistingFlow(block);
        updateProgress(block);
        return;
      }

      delete block.dataset.mmEditingStep;
      block.dataset.garment=value;
      stepSection(block,'color')?.classList.remove('mm-step-collapsed');
      var garment=(data.garments[type]||[]).find(function(g){return g.value===value;});
      renderColors(block,garment);
      showCoreDetails(block,type,garment&&garment.sizes,'');
      collapseMobileStep(block,'garment',(garment&&garment.label?garment.label:value));
      var colourSec=block.querySelector('[data-role="color-section"]');
      var locationsSec=block.querySelector('[data-role="locations-section"]');
      if(!colourSec||colourSec.classList.contains('mm-hidden')){
        show(locationsSec,true);
      }
      updateProgress(block);
      gentleAdvance(colourSec&&!colourSec.classList.contains('mm-hidden')?colourSec:locationsSec,event);
    }

    function addGarment(prefill){
      seq++;
      var node=template.content.firstElementChild.cloneNode(true);
      node.dataset.index=String(seq);
      node.querySelector('[data-role="garment-number"]').textContent='Garment '+seq;
      list.appendChild(node);
      activeBlock=node;
      fillTypeGrid(node);
      installGarmentFlow(node);
      node.addEventListener('pointerdown',function(){activeBlock=node;updateGlobalProgress();},{passive:true});
      node.addEventListener('click',function(event){
        var compactRemove=event.target.closest('[data-mm-remove-garment-compact]');
        if(compactRemove){
          event.preventDefault();
          removeGarmentBlock(node,false);
          return;
        }
        var edit=event.target.closest('[data-mm-edit-garment]');
        if(edit){
          event.preventDefault();
          expandGarmentBlock(node,true);
          return;
        }
        var change=event.target.closest('[data-mm-change-step]');
        if(!change)return;
        event.preventDefault();
        activeBlock=node;
        expandMobileStep(node,change.dataset.mmChangeStep);
        updateGlobalProgress();
      });
      var addColourBtn=node.querySelector('[data-mm-add-colour]');
      var extraWrap=node.querySelector('[data-role="extra-colours"]');
      addColourBtn.addEventListener('click',function(){addExtraColour(node);});

      extraWrap.addEventListener('change',function(event){
        var select=event.target.closest('[data-mm-extra-colour-select]');
        if(!select)return;
        var group=select.closest('[data-mm-extra-colour]');
        var other=group.querySelector('[data-mm-extra-colour-other]');
        show(other,select.value==='Other');
        updateProgress(node);
        if(group._mmSyncMiniColourFlow)group._mmSyncMiniColourFlow();
      });

      extraWrap.addEventListener('input',function(event){
        var group=event.target.closest('[data-mm-extra-colour]');
        if(!group)return;
        if(event.target.matches('[data-role="qty-extra"]')){
          syncQuantityEntered(event.target);
          updateExtraColourTotal(node,group);
        }else{
          if(event.target.matches('[data-mm-extra-colour-other]') && event.target.value.trim()){
            group.classList.remove('mm-extra-colour--editing-choice');
          }
          updateProgress(node);
        }
        if(group._mmSyncMiniColourFlow)group._mmSyncMiniColourFlow();
      });

      extraWrap.addEventListener('click',function(event){
        var removeExtra=event.target.closest('[data-mm-remove-extra-colour]');
        if(removeExtra){
          event.preventDefault();
          var removeGroup=removeExtra.closest('[data-mm-extra-colour]');
          var wasMini=removeGroup&&removeGroup.classList.contains('mm-extra-colour--active');
          if(removeGroup)removeGroup.remove();
          if(wasMini)node.classList.remove('mm-garment-colour-editing');
          refreshExtraColourNumbers(node);
          syncAddColourButton(node);
          updateProgress(node);
          if(wasMini){
            collapseGarmentBlock(node);
            updateGlobalProgress();
          }
          return;
        }

      });

      updateProgress(node);
      var remove=node.querySelector('[data-mm-remove-garment]');
      remove.addEventListener('click',function(){
        removeGarmentBlock(node,false);
      });
      if(list.children.length===1) remove.classList.add('mm-hidden');
      else Array.from(list.children).forEach(function(b){show(b.querySelector('[data-mm-remove-garment]'),true);});
      if(prefill && prefill[0]){
        var typeInput=Array.from(node.querySelectorAll('[data-role="type-grid"] input')).find(function(x){return x.value===prefill[0];});
        if(typeInput){typeInput.checked=true;typeInput.dispatchEvent(new Event('change',{bubbles:true}));}
        if(prefill[1]){
          setTimeout(function(){
            if(prefill[0]!=='Other'){
              var mode=node.querySelector('[data-role="mode-grid"] input[value="exact"]');
              if(mode){mode.checked=true;mode.dispatchEvent(new Event('change',{bubbles:true}));}
            }
            setTimeout(function(){
              var gi=Array.from(node.querySelectorAll('[data-role="garment-grid"] input')).find(function(x){return x.value===prefill[1];});
              if(gi){gi.checked=true;gi.dispatchEvent(new Event('change',{bubbles:true}));}
            },0);
          },0);
        }
      }
    }

    function renumber(){
      Array.from(list.children).forEach(function(b,i){
        b.querySelector('[data-role="garment-number"]').textContent='Garment '+(i+1);
        show(b.querySelector('[data-mm-remove-garment]'),list.children.length>1);
        refreshCompactSummary(b);
        updateProgress(b);
      });
    }

    function blockSummary(block,num){
      var type=block.dataset.type||'';
      var mode=block.dataset.mode||'';
      var parts=['Garment '+num+': '+type];

      if(type==='Other'){
        var desc=block.querySelector('[data-role="other-description"]').value.trim();
        var col=block.querySelector('[data-role="other-colour"]').value.trim();
        if(desc)parts.push('Description: '+desc);
        if(col)parts.push('Colour: '+col);
        var otherQty=parseInt(block.querySelector('[data-role="other-qty"]').value||'0',10)||0;
        if(otherQty>0)parts.push('Quantity: '+otherQty);
        return parts.join('\n');
      }

      if(mode==='lowest')parts.push('Selection: Lowest-cost option');
      if(mode==='recommend')parts.push('Selection: Recommend one for me');
      if(mode==='exact'){
        var gv=selectedValue(block.querySelector('[data-role="garment-grid"]'));
        var garment=(data.garments[type]||[]).find(function(x){return x.value===gv;});
        if(garment)parts.push('Exact garment: '+garment.label);
      }

      colourBreakdowns(block).forEach(function(item,index){
        parts.push((index===0?'Colour':'Additional colour '+(index+1))+': '+item.colour);
        if(item.sizes.length)parts.push('Quantities ('+item.colour+'): '+item.sizes.join(', '));
      });

      var locs=selectedValues(block.querySelector('[data-role="locations-grid"]'));
      if(locs.length)parts.push('Print locations: '+locs.join(', '));
      return parts.join('\n');
    }

    function garmentPayload(block,num){
      var type=block.dataset.type||'';
      var mode=block.dataset.mode||'';
      var payload={
        number:num,
        type:type,
        mode:mode,
        selection:'',
        exactGarment:'',
        description:'',
        colour:'',
        quantity:0,
        colours:[],
        printLocations:[]
      };

      if(type==='Other'){
        payload.selection='Other item';
        payload.description=block.querySelector('[data-role="other-description"]').value.trim();
        payload.colour=block.querySelector('[data-role="other-colour"]').value.trim();
        payload.quantity=parseInt(block.querySelector('[data-role="other-qty"]').value||'0',10)||0;
        return payload;
      }

      if(mode==='lowest')payload.selection='Lowest-cost option';
      if(mode==='recommend')payload.selection='Recommend one for me';
      if(mode==='exact'){
        payload.selection='Exact garment';
        var gv=selectedValue(block.querySelector('[data-role="garment-grid"]'));
        var garment=(data.garments[type]||[]).find(function(x){return x.value===gv;});
        if(garment)payload.exactGarment=garment.label;
      }

      payload.colours=colourBreakdowns(block).map(function(item){
        return {
          colour:item.colour,
          total:item.total,
          sizes:item.sizes.slice()
        };
      });
      payload.quantity=payload.colours.reduce(function(sum,item){return sum+(item.total||0);},0);
      payload.printLocations=selectedValues(block.querySelector('[data-role="locations-grid"]'));
      return payload;
    }

    function validateBlock(block){
      errorAt(block,'');
      var type=block.dataset.type;
      if(!type){errorAt(block,'Choose a garment type.');return false;}
      if(type==='Other'){
        if(!block.querySelector('[data-role="other-description"]').value.trim()){errorAt(block,'Tell us what item you are looking for.');return false;}
        var otherQty=parseInt(block.querySelector('[data-role="other-qty"]').value||'0',10)||0;
        if(otherQty<1){errorAt(block,'Enter the quantity you need.');return false;}
        return true;
      }else{
        var mode=block.dataset.mode;
        if(!mode){errorAt(block,'Choose how you would like us to select this garment.');return false;}
        if(mode==='exact' && !selectedValue(block.querySelector('[data-role="garment-grid"]'))){errorAt(block,'Choose an exact garment.');return false;}
        var colorBox=block.querySelector('[data-role="color-grid"]');
        if(mode==='exact' && !block.querySelector('[data-role="color-section"]').classList.contains('mm-hidden') && !selectedValue(colorBox)){errorAt(block,'Choose a garment colour.');return false;}
        if((mode==='lowest'||mode==='recommend')){
          var pv=selectedValue(block.querySelector('[data-role="preferred-grid"]'));
          if(!pv){errorAt(block,'Choose a preferred garment colour.');return false;}
          if(pv==='Other'&&!block.querySelector('[data-role="preferred-other-input"]').value.trim()){errorAt(block,'Enter the colour you are looking for.');return false;}
        }
        if(!extraColoursValid(block)){errorAt(block,'Choose a colour and quantity for each added colour.');return false;}
        var colourNames=colourBreakdowns(block).map(function(item){return item.colour.trim().toLowerCase();});
        if(new Set(colourNames).size!==colourNames.length){errorAt(block,'Choose a different colour for each colour group.');return false;}
        if(!selectedValues(block.querySelector('[data-role="locations-grid"]')).length){errorAt(block,'Choose at least one print location.');return false;}
        if(block.dataset.mmLocationsConfirmed!=='1'){errorAt(block,'Continue to quantities after choosing your print locations.');return false;}
      }
      var total=0;
      block.querySelectorAll('[data-role="qty"]').forEach(function(i){total+=(parseInt(i.value||'0',10)||0);});
      if(total<1){errorAt(block,'Enter at least one garment quantity.');return false;}
      return true;
    }

    addBtn.addEventListener('click',function(){
      if(activeBlock&&progressState(activeBlock).complete){
        collapseGarmentBlock(activeBlock);
      }
      addGarment(null);
      renumber();
      updateGlobalProgress();

      if(activeBlock){
        markNewSection(activeBlock,'');
        var start=activeBlock.querySelector('[data-role="type-grid"]')||activeBlock;
        window.setTimeout(function(){
          mmFocusAndScroll(start);
        },40);
      }
    });

    if(reviewBtn)reviewBtn.addEventListener('click',openReview);
    root.querySelectorAll('[data-mm-close-review]').forEach(function(btn){btn.addEventListener('click',closeReview);});
    if(reviewList)reviewList.addEventListener('click',function(event){
      var remove=event.target.closest('[data-mm-review-remove]');
      if(remove){
        var removeIndex=parseInt(remove.dataset.mmReviewRemove,10);
        var removeBlock=Array.from(list.children)[removeIndex];
        removeGarmentBlock(removeBlock,true);
        return;
      }

      var edit=event.target.closest('[data-mm-review-edit]');
      if(!edit)return;
      var index=parseInt(edit.dataset.mmReviewEdit,10);
      var block=Array.from(list.children)[index];
      closeReview();
      if(block)expandGarmentBlock(block,true);
    });
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&review&&!review.classList.contains('mm-hidden'))closeReview();
    });

    if(finalReview)finalReview.addEventListener('click',function(event){
      var editGarment=event.target.closest('[data-mm-final-edit-garment]');
      if(editGarment){
        var editIndex=parseInt(editGarment.dataset.mmFinalEditGarment,10);
        var editBlock=Array.from(list.children)[editIndex];
        setQuoteStage('build',false);
        if(editBlock)expandGarmentBlock(editBlock,true);
        return;
      }

      var removeGarment=event.target.closest('[data-mm-final-remove-garment]');
      if(removeGarment){
        var removeIndex=parseInt(removeGarment.dataset.mmFinalRemoveGarment,10);
        var removeBlock=Array.from(list.children)[removeIndex];
        setQuoteStage('build',false);
        removeGarmentBlock(removeBlock,false);
        return;
      }

      if(event.target.closest('[data-mm-final-edit-artwork]')){
        setQuoteStage('build',false);
        setTimeout(function(){if(artworkSection)artworkSection.scrollIntoView({behavior:'smooth',block:'center'});},20);
        return;
      }

      if(event.target.closest('[data-mm-final-edit-details]')){
        setQuoteStage('details',true);
        return;
      }

      if(event.target.closest('[data-mm-final-edit-notes]')){
        setQuoteStage('details',false);
        setTimeout(function(){if(notesSection)notesSection.scrollIntoView({behavior:'smooth',block:'center'});},20);
      }
    });

    form._mmRenderFinalReview=function(){
      renderFinalReview();
      refreshFlowState();
      updateNextStepGuide();
    };

    if(nextStepButton)nextStepButton.addEventListener('click',jumpToNextTarget);
    root.addEventListener('input',function(event){
      acknowledgeNextTarget(event);
      renderFinalReview();
      refreshFlowState();
      updateNextStepGuide();
    });
    root.addEventListener('change',function(event){
      acknowledgeNextTarget(event);
      renderFinalReview();
      refreshFlowState();
      updateNextStepGuide();
    });
    if(artworkInput)artworkInput.addEventListener('change',function(){
      setTimeout(function(){
        refreshFlowState();
        updateNextStepGuide();
      },0);
    });

    prepareQuoteCopy();
    ensureFlowControls();
    addGarment(slugChoice(data));
    renumber();
    setQuoteStage('build',false);
    updateGlobalProgress();
    renderFinalReview();
    root.classList.add('mm-quote-ready');

    async function submitQuoteRequest(){
      if(form.dataset.mmHandling==='1'||form.dataset.mmSubmitting==='1')return;

      var requiredInvalid=mmValidateRequiredFields(form);
      var blocks=Array.from(list.children);
      var garmentValid=true;
      blocks.forEach(function(block){
        var ok=validateBlock(block);
        block.classList.toggle('mm-section-invalid',!ok);
        if(!ok)garmentValid=false;
      });

      var artworkMissing=!(Array.isArray(form._mmSelectedFiles)&&form._mmSelectedFiles.length);
      if(artworkSection)artworkSection.classList.toggle('mm-section-invalid',artworkMissing);

      if(requiredInvalid.length||!garmentValid||artworkMissing){
        if(!garmentValid||artworkMissing)setQuoteStage('build',false);
        else if(requiredInvalid.length)setQuoteStage('details',false);
        updateNextStepGuide();
        var first=form.querySelector('.mm-invalid,.mm-section-invalid [data-mm-custom-error],.mm-section-invalid[data-mm-artwork-section],.mm-garment-block.mm-section-invalid');
        mmFocusAndScroll(first||requiredInvalid[0]);
        return;
      }

      summaryInput.value=blocks.map(function(b,i){return blockSummary(b,i+1);}).join('\n\n');
      mmRememberSuccessName(mmFieldValue(form,'contact[First Name]'),'/pages/quote-request-received');
      form.dataset.mmHandling='1';

      try{
        await handleUploads(form,true);

        var payload={
          kind:'quote',
          submissionId:mmSubmissionId(form),
          source:location.href,
          contact:{
            company:mmFieldValue(form,'contact[Company]'),
            firstName:mmFieldValue(form,'contact[First Name]'),
            lastName:mmFieldValue(form,'contact[Last Name]'),
            email:mmFieldValue(form,'contact[email]'),
            addressLine1:mmFieldValue(form,'contact[Address Line 1]'),
            addressLine2:mmFieldValue(form,'contact[Address Line 2]'),
            city:mmFieldValue(form,'contact[City]'),
            region:mmFieldValue(form,'contact[State / Province]'),
            postalCode:mmFieldValue(form,'contact[Zip / Postal Code]'),
            country:mmFieldValue(form,'contact[Country]')
          },
          garments:blocks.map(function(b,i){return garmentPayload(b,i+1);}),
          garmentText:summaryInput.value,
          specialRequests:mmFieldValue(form,'contact[Questions / Special Requests]'),
          estimatorOriginal:mmFieldValue(form,'contact[Original Estimator Details]'),
          estimatorUpdated:mmFieldValue(form,'contact[Updated Estimator Details]'),
          artwork:mmUploadedArtwork(form)
        };

        await mmSendNotification(form,payload,'Sending quote request…');
      }catch(err){
        if(mmHasUploadedArtwork(form)){
          console.warn('Custom quote notification failed; using Shopify fallback.',err);
          mmSubmitShopifyFallback(form);
          return;
        }
        form.dataset.mmHandling='0';
        var st=form.querySelector('[data-mm-upload-status]');
        if(st){st.textContent=err && err.message ? err.message : 'Artwork upload failed. Please try again.';st.className='mm-status mm-error';}
        return;
      }

      form.dataset.mmSubmitting='1';
      window.location.replace('/pages/quote-request-received');
    }

    mmBindCustomSubmit(form,submitButton,submitQuoteRequest);
    root.dataset.mmQuoteInitialized='1';
    return true;
  }

  function uploadPartWithProgress(url,chunk,onProgress){
    return new Promise(function(resolve,reject){
      var xhr=new XMLHttpRequest();
      xhr.open('PUT',url,true);
      xhr.setRequestHeader('Content-Type','application/octet-stream');
      xhr.upload.onprogress=function(e){
        if(e.lengthComputable && onProgress) onProgress(e.loaded,e.total);
      };
      xhr.onerror=function(){reject(new Error('Artwork upload failed.'));};
      xhr.onload=function(){
        var data={};
        try{data=JSON.parse(xhr.responseText||'{}');}catch(_){}
        if(xhr.status>=200&&xhr.status<300) resolve(data);
        else reject(new Error(data.error||'Artwork upload failed.'));
      };
      xhr.send(chunk);
    });
  }

  async function uploadOne(worker,file,status,index,total){
    status.textContent='Uploading artwork '+index+' of '+total+' — 1%';
    var initResp=await fetch(worker+'/api/upload/init',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({name:file.name,size:file.size,type:file.type||'application/octet-stream'})});
    var init=await initResp.json();
    if(!initResp.ok) throw new Error(init.error||'Could not start artwork upload.');
    var parts=[], partSize=init.partSize||8388608, partNumber=1;
    try{
      for(var start=0;start<file.size;start+=partSize){
        var chunk=file.slice(start,Math.min(start+partSize,file.size));
        var url=worker+'/api/upload/part?key='+encodeURIComponent(init.key)+'&uploadId='+encodeURIComponent(init.uploadId)+'&partNumber='+partNumber;
        var p=await uploadPartWithProgress(url,chunk,function(loaded){
          var overall=Math.min(file.size,start+loaded);
          var pct=Math.max(1,Math.min(95,Math.floor((overall/file.size)*95)));
          status.textContent='Uploading artwork '+index+' of '+total+' — '+pct+'%';
        });
        parts.push({partNumber:p.partNumber,etag:p.etag});
        partNumber++;
      }
      status.textContent='Finalizing artwork '+index+' of '+total+'…';
      var cr=await fetch(worker+'/api/upload/complete?key='+encodeURIComponent(init.key)+'&uploadId='+encodeURIComponent(init.uploadId),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({parts:parts})});
      var done=await cr.json();
      if(!cr.ok) throw new Error(done.error||'Could not finish artwork upload.');
      return done.fileUrl;
    }catch(err){
      try{await fetch(worker+'/api/upload/abort?key='+encodeURIComponent(init.key)+'&uploadId='+encodeURIComponent(init.uploadId),{method:'POST'});}catch(_){}
      throw err;
    }
  }

  function setSubmitDisabled(form,disabled){
    form.querySelectorAll('.mm-submit,button[type="submit"],input[type="submit"]').forEach(function(btn){
      btn.disabled=!!disabled;
    });
  }

  function fileSignature(files){
    return files.map(function(f){return [f.name,f.size,f.lastModified].join(':');}).join('|');
  }

  async function handleUploads(form,required){
    var input=form.querySelector('[data-mm-files]');
    var hidden=form.querySelector('[data-mm-file-links]');
    var status=form.querySelector('[data-mm-upload-status]');
    if(!input||!hidden)return;

    var files=Array.isArray(form._mmSelectedFiles) ? form._mmSelectedFiles.slice() : Array.from(input.files||[]);
    form._mmUploadedBySignature=form._mmUploadedBySignature||{};
    form._mmFileStates=form._mmFileStates||{};

    if(required && !files.length)throw new Error('Please attach your artwork.');
    if(!files.length){
      hidden.value='';
      form._mmUploadedFiles=[];
      delete form.dataset.mmUploadedSignature;
      if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
      return;
    }

    var signature=fileSignature(files);
    if(hidden.value.trim() && form.dataset.mmUploadedSignature===signature){
      if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
      return;
    }

    if(form._mmUploadPromise){
      await form._mmUploadPromise;
      return handleUploads(form,required);
    }

    var worker=form.closest('[data-mm-upload-endpoint]')?.dataset.mmUploadEndpoint;
    if(!worker)throw new Error('Artwork upload service is not configured.');

    setSubmitDisabled(form,true);

    form._mmUploadPromise=(async function(){
      var links=[];
      for(var i=0;i<files.length;i++){
        var file=files[i];
        var key=fileSignature([file]);
        var existing=form._mmUploadedBySignature[key];
        var url=existing&&existing.url ? existing.url : '';

        if(!url){
          form._mmFileStates[key]='uploading';
          if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
          try{
            url=await uploadOne(worker,file,status,i+1,files.length);
          }catch(error){
            form._mmFileStates[key]='error';
            if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
            throw error;
          }
          form._mmUploadedBySignature[key]={
            name:file.name,
            url:url,
            type:file.type||'',
            size:file.size||0
          };
        }

        form._mmFileStates[key]='uploaded';
        links.push(url);
        if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
      }

      hidden.value=links.map(function(u,i){
        return (files[i]?.name||('Artwork '+(i+1)))+': '+u;
      }).join('\n');

      form._mmUploadedFiles=links.map(function(u,i){
        var file=files[i];
        return {
          name:file?.name||('Artwork '+(i+1)),
          url:u,
          type:file?.type||'',
          size:file?.size||0
        };
      });

      form.dataset.mmUploadedSignature=signature;
      if(status){
        status.textContent=files.length===1 ? '1 file attached — ready to submit.' : (files.length+' files attached — ready to submit.');
        status.className='mm-status mm-success';
      }
      if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
    })();

    try{
      await form._mmUploadPromise;
    }finally{
      form._mmUploadPromise=null;
      setSubmitDisabled(form,false);
      if(typeof form._mmRenderFiles==='function')form._mmRenderFiles();
    }
  }
  function mmValidationSummary(form){
    var summary=form.querySelector('[data-mm-validation-summary]');
    if(summary)return summary;
    summary=document.createElement('div');
    summary.className='mm-form-validation-summary';
    summary.dataset.mmValidationSummary='1';
    summary.setAttribute('role','alert');
    summary.hidden=true;
    var submit=form.querySelector('.mm-submit');
    if(submit&&submit.parentNode)submit.parentNode.insertBefore(summary,submit);
    else form.appendChild(summary);
    return summary;
  }

  function mmRequiredMessage(field){
    if(field.validity&&field.validity.valueMissing)return 'Required.';
    if(field.validity&&field.validity.typeMismatch)return field.type==='email' ? 'Enter a valid email address.' : 'Please check this field.';
    if(field.validity&&field.validity.patternMismatch)return 'Please check this field.';
    return 'Please check this field.';
  }

  function mmClearFieldValidation(field){
    field.classList.remove('mm-invalid');
    field.removeAttribute('aria-invalid');
    var wrap=field.closest('.mm-field');
    if(wrap){
      wrap.classList.remove('mm-field--invalid');
      var old=wrap.querySelector('[data-mm-required-error]');
      if(old)old.remove();
    }
  }

  function mmMarkFieldInvalid(field){
    field.classList.add('mm-invalid');
    field.setAttribute('aria-invalid','true');
    var wrap=field.closest('.mm-field');
    if(!wrap)return;
    wrap.classList.add('mm-field--invalid');
    var error=wrap.querySelector('[data-mm-required-error]');
    if(!error){
      error=document.createElement('p');
      error.className='mm-field-error';
      error.dataset.mmRequiredError='1';
      wrap.appendChild(error);
    }
    error.textContent=mmRequiredMessage(field);
  }

  function mmValidateRequiredFields(form){
    var invalid=[];
    form.querySelectorAll('input[required],textarea[required],select[required]').forEach(function(field){
      if(field.disabled||field.type==='hidden')return;
      if(field.checkValidity()){
        mmClearFieldValidation(field);
      }else{
        mmMarkFieldInvalid(field);
        invalid.push(field);
      }
    });
    return invalid;
  }

  function mmShowValidationSummary(form){
    var summary=mmValidationSummary(form);
    summary.textContent='Please complete the required fields highlighted below.';
    summary.hidden=false;
  }

  function mmMaybeHideValidationSummary(form){
    var summary=form.querySelector('[data-mm-validation-summary]');
    if(!summary)return;
    var stillInvalid=form.querySelector('.mm-invalid,[data-mm-custom-error],.mm-section-invalid');
    if(!stillInvalid)summary.hidden=true;
  }

  function mmFocusAndScroll(target){
    if(!target)return;
    var field=target.matches&&target.matches('input,textarea,select,button') ? target : target.querySelector&&target.querySelector('input:not([type="hidden"]),textarea,select,button');
    var scrollTarget=field?.closest('.mm-field')||target;
    try{
      if(field)field.focus({preventScroll:true});
    }catch(_){
      if(field)field.focus();
    }
    window.setTimeout(function(){
      if(scrollTarget&&scrollTarget.scrollIntoView)scrollTarget.scrollIntoView({behavior:'smooth',block:'center'});
    },40);
    window.setTimeout(function(){
      if(scrollTarget&&scrollTarget.scrollIntoView)scrollTarget.scrollIntoView({behavior:'smooth',block:'center'});
    },320);
  }

  function mmWireValidationFeedback(root){
    var form=root.querySelector('form');
    if(!form)return;
    mmValidationSummary(form);
    form.addEventListener('input',function(event){
      var field=event.target;
      if(!field.matches||!field.matches('input[required],textarea[required],select[required]'))return;
      if(field.checkValidity())mmClearFieldValidation(field);
      mmMaybeHideValidationSummary(form);
    });
    form.addEventListener('change',function(event){
      var field=event.target;
      if(!field.matches||!field.matches('input[required],textarea[required],select[required]'))return;
      if(field.checkValidity())mmClearFieldValidation(field);
      mmMaybeHideValidationSummary(form);
    });
  }

  function mmFieldValue(form,name){
    var field=form.elements&&form.elements.namedItem ? form.elements.namedItem(name) : null;
    if(!field)return '';
    if(typeof field.value==='string')return field.value.trim();
    return '';
  }

  function mmSubmissionId(form){
    if(form.dataset.mmSubmissionId)return form.dataset.mmSubmissionId;
    var id='';
    try{
      if(window.crypto&&typeof window.crypto.randomUUID==='function')id=window.crypto.randomUUID();
    }catch(_){}
    if(!id)id='mm-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,12);
    form.dataset.mmSubmissionId=id;
    return id;
  }

  function mmUploadedArtwork(form){
    return Array.isArray(form._mmUploadedFiles)
      ? form._mmUploadedFiles.map(function(file){
          return {name:file.name,url:file.url,type:file.type,size:file.size};
        })
      : [];
  }

  function mmHasUploadedArtwork(form){
    var hidden=form.querySelector('[data-mm-file-links]');
    return !!(hidden&&hidden.value.trim());
  }

  async function mmSendNotification(form,payload,statusText){
    var root=form.closest('[data-mm-upload-endpoint]');
    var worker=root&&root.dataset.mmUploadEndpoint;
    if(!worker)throw new Error('Notification service is not configured.');

    var status=form.querySelector('[data-mm-upload-status]');
    setSubmitDisabled(form,true);
    if(status){
      status.textContent=statusText||'Sending…';
      status.className='mm-status';
    }

    var response;
    var data={};
    try{
      response=await fetch(worker+'/api/notify',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload)
      });
      try{data=await response.json();}catch(_){}
    }catch(error){
      setSubmitDisabled(form,false);
      throw error;
    }

    if(!response.ok||!data.ok){
      setSubmitDisabled(form,false);
      throw new Error(data.error||'Notification could not be sent.');
    }
    return data;
  }

  function mmBindCustomSubmit(form,button,handler){
    if(!form||!button)return;
    button.type='button';
    button.addEventListener('click',handler);
    form.addEventListener('submit',function(e){
      if(form.dataset.mmNativeFallback==='1')return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handler();
    },true);
  }

  function mmRememberSuccessName(name,path){
    var first=String(name||'').trim().split(/\s+/)[0]||'';
    if(!first)return;
    try{
      sessionStorage.setItem('mmFormSuccess',JSON.stringify({
        firstName:first,
        path:path,
        savedAt:Date.now()
      }));
    }catch(_){}
  }

  function mmSubmitShopifyFallback(form){
    setSubmitDisabled(form,false);
    form.dataset.mmNativeFallback='1';
    form.dataset.mmSubmitting='1';
    var button=form.querySelector('.mm-submit');
    if(button)button.type='submit';
    if(typeof form.requestSubmit==='function')form.requestSubmit(button||undefined);
    else form.submit();
  }

  function initContact(root){
    var form=root.querySelector('form');
    var submitButton=form.querySelector('.mm-submit');

    async function submitContactMessage(){
      if(form.dataset.mmHandling==='1'||form.dataset.mmSubmitting==='1')return;
      var requiredInvalid=mmValidateRequiredFields(form);
      if(requiredInvalid.length){
        mmShowValidationSummary(form);
        mmFocusAndScroll(requiredInvalid[0]);
        return;
      }
      mmRememberSuccessName(mmFieldValue(form,'contact[name]'),'/pages/contact-form-submitted');
      form.dataset.mmHandling='1';

      try{
        await handleUploads(form,false);

        var payload={
          kind:'contact',
          submissionId:mmSubmissionId(form),
          source:location.href,
          contact:{
            name:mmFieldValue(form,'contact[name]'),
            email:mmFieldValue(form,'contact[email]'),
            phone:mmFieldValue(form,'contact[phone]')
          },
          message:mmFieldValue(form,'contact[body]'),
          artwork:mmUploadedArtwork(form)
        };

        await mmSendNotification(form,payload,'Sending message…');
      }catch(err){
        console.warn('Custom contact notification failed; using Shopify fallback.',err);
        mmSubmitShopifyFallback(form);
        return;
      }

      form.dataset.mmSubmitting='1';
      window.location.replace('/pages/contact-form-submitted');
    }

    mmBindCustomSubmit(form,submitButton,submitContactMessage);
  }

  function wireFiles(root,required){
    var form=root.querySelector('form');
    var input=root.querySelector('[data-mm-files]');
    var list=root.querySelector('[data-mm-file-list]');
    var prompt=root.querySelector('[data-mm-file-prompt]');
    var button=root.querySelector('[data-mm-file-button]');
    var status=form&&form.querySelector('[data-mm-upload-status]');
    var hidden=form&&form.querySelector('[data-mm-file-links]');
    if(!form||!input||!list)return;

    form._mmSelectedFiles=form._mmSelectedFiles||[];
    form._mmUploadedBySignature=form._mmUploadedBySignature||{};
    form._mmFileStates=form._mmFileStates||{};
    form._mmArtworkPreviewUrls=form._mmArtworkPreviewUrls||new Map();

    function sizeLabel(file){
      var mb=file.size/(1024*1024);
      return mb>=1 ? mb.toFixed(mb>=10?0:1)+' MB' : Math.max(1,Math.round(file.size/1024))+' KB';
    }

    function syncUploadedState(){
      var files=form._mmSelectedFiles||[];
      var uploaded=[];
      var links=[];
      files.forEach(function(file){
        var key=fileSignature([file]);
        var saved=form._mmUploadedBySignature[key];
        if(saved&&saved.url){
          uploaded.push({name:file.name,url:saved.url,type:file.type||'',size:file.size||0});
          links.push(file.name+': '+saved.url);
        }
      });
      form._mmUploadedFiles=uploaded;
      if(hidden)hidden.value=links.join('\n');
    }

    function renderSelectedFiles(){
      var files=form._mmSelectedFiles||[];
      var locked=files.some(function(file){return form._mmFileStates[fileSignature([file])]==='uploading';});

      if(button)button.textContent=files.length ? '+ Add More Artwork' : 'Upload Artwork';
      if(prompt)prompt.textContent=files.length ? (files.length+' file'+(files.length===1?'':'s')+' attached') : '';

      list.innerHTML=files.map(function(file,index){
        var key=fileSignature([file]);
        var state=form._mmFileStates[key]||'selected';
        var stateText=state==='uploaded' ? 'Uploaded' : state==='uploading' ? 'Uploading…' : state==='error' ? 'Upload failed' : 'Selected';
        var previewable=/^image\//i.test(file.type||'') || /\.(?:jpe?g|png|svg)$/i.test(file.name||'');
        var previewUrl=previewable ? form._mmArtworkPreviewUrls.get(key) : '';
        if(previewable && !previewUrl && window.URL && URL.createObjectURL){
          previewUrl=URL.createObjectURL(file);
          form._mmArtworkPreviewUrls.set(key,previewUrl);
        }
        var preview=previewUrl
          ? '<img class="mm-file-item__preview" src="'+esc(previewUrl)+'" alt="Artwork preview">'
          : '';
        return '<li class="mm-file-item'+(state==='error'?' is-error':'')+'">'
          +preview
          +'<div class="mm-file-item__copy"><strong>'+esc(file.name)+'</strong><span>'+esc(sizeLabel(file))+' · '+esc(stateText)+'</span></div>'
          +'<button type="button" class="mm-file-item__remove" data-mm-remove-file="'+index+'"'+(locked?' disabled':'')+'>Remove</button>'
          +'</li>';
      }).join('');

      root.querySelector('[data-mm-artwork-section]')?.classList.remove('mm-section-invalid');
      if(typeof form._mmRenderFinalReview==='function')form._mmRenderFinalReview();
    }

    form._mmRenderFiles=renderSelectedFiles;

    list.addEventListener('click',function(event){
      var remove=event.target.closest('[data-mm-remove-file]');
      if(!remove||remove.disabled)return;
      var index=parseInt(remove.dataset.mmRemoveFile,10);
      if(!Number.isInteger(index)||!form._mmSelectedFiles[index])return;

      var file=form._mmSelectedFiles[index];
      var key=fileSignature([file]);
      var previewUrl=form._mmArtworkPreviewUrls&&form._mmArtworkPreviewUrls.get(key);
      if(previewUrl && window.URL && URL.revokeObjectURL){
        try{URL.revokeObjectURL(previewUrl);}catch(_){}
        form._mmArtworkPreviewUrls.delete(key);
      }
      form._mmSelectedFiles.splice(index,1);
      delete form._mmUploadedBySignature[key];
      delete form._mmFileStates[key];
      delete form.dataset.mmUploadedSignature;
      syncUploadedState();
      renderSelectedFiles();

      if(status){
        if(!form._mmSelectedFiles.length){
          status.textContent='';
          status.className='mm-status';
        }else{
          var count=form._mmSelectedFiles.length;
          status.textContent=count===1 ? '1 file attached.' : (count+' files attached.');
          status.className='mm-status mm-success';
        }
      }
      mmMaybeHideValidationSummary(form);
    });

    input.addEventListener('change',function(){
      var incoming=Array.from(input.files||[]);
      var seen=new Set((form._mmSelectedFiles||[]).map(function(file){return fileSignature([file]);}));
      incoming.forEach(function(file){
        var key=fileSignature([file]);
        if(!seen.has(key)){
          seen.add(key);
          form._mmSelectedFiles.push(file);
          form._mmFileStates[key]='selected';
        }
      });

      input.value='';
      delete form.dataset.mmUploadedSignature;
      renderSelectedFiles();
      root.querySelector('[data-mm-artwork-section]')?.classList.remove('mm-section-invalid');
      mmMaybeHideValidationSummary(form);

      if(!form._mmSelectedFiles.length){
        if(status){status.textContent='';status.className='mm-status';}
        return;
      }

      handleUploads(form,required).catch(function(err){
        if(status){
          status.textContent=err&&err.message ? err.message : 'File upload failed. Please choose the file again or retry.';
          status.className='mm-status mm-error';
        }
      });
    });

    renderSelectedFiles();
  }
  function wireMobileAutofillAdvance(root){
    var form=root.querySelector('form');
    if(!form)return;

    var fields=Array.from(form.querySelectorAll('input.mm-input[required][autocomplete],textarea.mm-textarea[required]'));
    if(!fields.length)return;

    function isMobile(){
      return window.matchMedia&&window.matchMedia('(max-width: 749px)').matches;
    }

    function nextEmptyField(index){
      return fields.slice(index+1).find(function(candidate){
        return !candidate.disabled&&candidate.offsetParent!==null&&!String(candidate.value||'').trim();
      })||null;
    }

    function advanceFrom(index){
      if(!isMobile())return;
      var next=nextEmptyField(index);
      if(!next)return;
      mmFocusAndScroll(next);
    }

    fields.forEach(function(field,index){
      var previousValue=String(field.value||'');
      var lastManualAt=0;
      var lastPasteAt=0;
      var poll=null;

      if(field.tagName==='INPUT'&&index<fields.length-1)field.enterKeyHint='next';

      function stopPoll(){
        if(poll){clearInterval(poll);poll=null;}
      }

      function startPoll(){
        stopPoll();
        previousValue=String(field.value||'');
        poll=setInterval(function(){
          if(document.activeElement!==field){stopPoll();return;}
          var current=String(field.value||'');
          if(current===previousValue)return;
          var wasEmpty=!previousValue.trim();
          previousValue=current;
          if(!current.trim()||!wasEmpty)return;
          var now=Date.now();
          if((now-lastManualAt)>350&&(now-lastPasteAt)>350){
            stopPoll();
            window.setTimeout(function(){advanceFrom(index);},30);
          }
        },90);
      }

      field.addEventListener('focus',startPoll);
      field.addEventListener('blur',stopPoll);

      field.addEventListener('beforeinput',function(event){
        if(event.inputType==='insertText'||event.inputType==='deleteContentBackward'||event.inputType==='deleteContentForward'){
          lastManualAt=Date.now();
        }
      });

      field.addEventListener('keydown',function(event){
        lastManualAt=Date.now();
        if(event.key!=='Enter'||field.tagName!=='INPUT'||!isMobile())return;
        var next=nextEmptyField(index);
        if(next){
          event.preventDefault();
          mmFocusAndScroll(next);
        }
      });

      field.addEventListener('paste',function(){lastPasteAt=Date.now();});

      field.addEventListener('animationstart',function(event){
        if(event.animationName!=='mmAutofillStart'||!String(field.value||'').trim())return;
        stopPoll();
        window.setTimeout(function(){advanceFrom(index);},40);
      });

      field.addEventListener('input',function(event){
        if(!isMobile()||!String(field.value||'').trim())return;
        var autofilled=false;
        try{autofilled=field.matches(':-webkit-autofill');}catch(_){}
        if(autofilled||event.inputType==='insertReplacementText'){
          stopPoll();
          window.setTimeout(function(){advanceFrom(index);},40);
        }
      });
    });
  }
  function wireArtworkTips(root){
    var details=root.querySelector('.mm-artwork-tips');
    if(!details)return;
    var summary=details.querySelector('summary');
    var desktopHover=window.matchMedia ? window.matchMedia('(hover:hover) and (pointer:fine)') : null;

    function isDesktopHover(){
      return !!(desktopHover&&desktopHover.matches);
    }

    details.addEventListener('mouseenter',function(){
      if(isDesktopHover())details.open=true;
    });

    details.addEventListener('mouseleave',function(){
      if(isDesktopHover())details.open=false;
    });

    if(summary){
      summary.addEventListener('click',function(event){
        if(isDesktopHover()){
          event.preventDefault();
          details.open=true;
        }
      });
    }
  }

  function boot(){
    document.querySelectorAll('[data-mm-quote]').forEach(function(root){
      wireFiles(root,true);
      wireArtworkTips(root);
      wireMobileAutofillAdvance(root);
      mmWireValidationFeedback(root);

      var attempts=0;
      function startQuote(){
        if(initQuote(root))return;
        attempts++;
        if(attempts<40)window.setTimeout(startQuote,100);
      }
      startQuote();
    });

    document.querySelectorAll('[data-mm-contact]').forEach(function(root){
      wireFiles(root,false);
      wireMobileAutofillAdvance(root);
      mmWireValidationFeedback(root);
      initContact(root);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();
